(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/common'), require('@angular/core'), require('@n3/ng-api-common'), require('@n3/ng-api-base-kit')) :
	typeof define === 'function' && define.amd ? define('ng-api-institution', ['exports', '@angular/common', '@angular/core', '@n3/ng-api-common', '@n3/ng-api-base-kit'], factory) :
	(factory((global.n3 = global.n3 || {}, global.n3.ngApiInstitution = {}),global.ng.common,global.ng.core,global.n3.ngApiCommon,global.n3.ngApiBaseKit));
}(this, (function (exports,common,core,ngApiCommon,ngApiBaseKit) { 'use strict';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

/**
 * @license Angular v5.2.9
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _DOM = /** @type {?} */ ((null));
/**
 * @return {?}
 */
function getDOM() {
    return _DOM;
}
/**
 * @param {?} adapter
 * @return {?}
 */

/**
 * @param {?} adapter
 * @return {?}
 */
function setRootDomAdapter(adapter) {
    if (!_DOM) {
        _DOM = adapter;
    }
}
/**
 * Provides DOM operations in an environment-agnostic way.
 *
 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 * @abstract
 */
var DomAdapter = /** @class */ (function () {
    function DomAdapter() {
        this.resourceLoaderType = /** @type {?} */ ((null));
    }
    Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
        /**
         * Maps attribute names to their corresponding property names for cases
         * where attribute name doesn't match property name.
         */
        get: /**
         * Maps attribute names to their corresponding property names for cases
         * where attribute name doesn't match property name.
         * @return {?}
         */
        function () { return this._attrToPropMap; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) { this._attrToPropMap = value; },
        enumerable: true,
        configurable: true
    });
    return DomAdapter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides DOM operations in any browser environment.
 *
 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 * @abstract
 */
var GenericBrowserDomAdapter = /** @class */ (function (_super) {
    __extends(GenericBrowserDomAdapter, _super);
    function GenericBrowserDomAdapter() {
        var _this = _super.call(this) || this;
        _this._animationPrefix = null;
        _this._transitionEnd = null;
        try {
            var /** @type {?} */ element_1 = _this.createElement('div', document);
            if (_this.getStyle(element_1, 'animationName') != null) {
                _this._animationPrefix = '';
            }
            else {
                var /** @type {?} */ domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                for (var /** @type {?} */ i = 0; i < domPrefixes.length; i++) {
                    if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
                        _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                        break;
                    }
                }
            }
            var /** @type {?} */ transEndEventNames_1 = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd otransitionend',
                transition: 'transitionend'
            };
            Object.keys(transEndEventNames_1).forEach(function (key) {
                if (_this.getStyle(element_1, key) != null) {
                    _this._transitionEnd = transEndEventNames_1[key];
                }
            });
        }
        catch (/** @type {?} */ e) {
            _this._animationPrefix = null;
            _this._transitionEnd = null;
        }
        return _this;
    }
    /**
     * @param {?} el
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getDistributedNodes = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return (/** @type {?} */ (el)).getDistributedNodes(); };
    /**
     * @param {?} el
     * @param {?} baseUrl
     * @param {?} href
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.resolveAndSetHref = /**
     * @param {?} el
     * @param {?} baseUrl
     * @param {?} href
     * @return {?}
     */
    function (el, baseUrl, href) {
        el.href = href == null ? baseUrl : baseUrl + '/../' + href;
    };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsDOMEvents = /**
     * @return {?}
     */
    function () { return true; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = /**
     * @return {?}
     */
    function () {
        return typeof (/** @type {?} */ (document.body)).createShadowRoot === 'function';
    };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getAnimationPrefix = /**
     * @return {?}
     */
    function () { return this._animationPrefix ? this._animationPrefix : ''; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getTransitionEnd = /**
     * @return {?}
     */
    function () { return this._transitionEnd ? this._transitionEnd : ''; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsAnimation = /**
     * @return {?}
     */
    function () {
        return this._animationPrefix != null && this._transitionEnd != null;
    };
    return GenericBrowserDomAdapter;
}(DomAdapter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _attrToPropMap = {
    'class': 'className',
    'innerHtml': 'innerHTML',
    'readonly': 'readOnly',
    'tabindex': 'tabIndex',
};
var DOM_KEY_LOCATION_NUMPAD = 3;
// Map to convert some key or keyIdentifier values to what will be returned by getEventKey
var _keyMap = {
    // The following values are here for cross-browser compatibility and to match the W3C standard
    // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
    '\b': 'Backspace',
    '\t': 'Tab',
    '\x7F': 'Delete',
    '\x1B': 'Escape',
    'Del': 'Delete',
    'Esc': 'Escape',
    'Left': 'ArrowLeft',
    'Right': 'ArrowRight',
    'Up': 'ArrowUp',
    'Down': 'ArrowDown',
    'Menu': 'ContextMenu',
    'Scroll': 'ScrollLock',
    'Win': 'OS'
};
// There is a bug in Chrome for numeric keypad keys:
// https://code.google.com/p/chromium/issues/detail?id=155654
// 1, 2, 3 ... are reported as A, B, C ...
var _chromeNumKeyPadMap = {
    'A': '1',
    'B': '2',
    'C': '3',
    'D': '4',
    'E': '5',
    'F': '6',
    'G': '7',
    'H': '8',
    'I': '9',
    'J': '*',
    'K': '+',
    'M': '-',
    'N': '.',
    'O': '/',
    '\x60': '0',
    '\x90': 'NumLock'
};
var nodeContains;
if (core.ɵglobal['Node']) {
    nodeContains = core.ɵglobal['Node'].prototype.contains || function (node) {
        return !!(this.compareDocumentPosition(node) & 16);
    };
}
/**
 * A `DomAdapter` powered by full browser DOM APIs.
 *
 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
var BrowserDomAdapter = /** @class */ (function (_super) {
    __extends(BrowserDomAdapter, _super);
    function BrowserDomAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} templateHtml
     * @return {?}
     */
    BrowserDomAdapter.prototype.parse = /**
     * @param {?} templateHtml
     * @return {?}
     */
    function (templateHtml) { throw new Error('parse not implemented'); };
    /**
     * @return {?}
     */
    BrowserDomAdapter.makeCurrent = /**
     * @return {?}
     */
    function () { setRootDomAdapter(new BrowserDomAdapter()); };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasProperty = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) { return name in element; };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setProperty = /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (el, name, value) { (/** @type {?} */ (el))[name] = value; };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getProperty = /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    function (el, name) { return (/** @type {?} */ (el))[name]; };
    /**
     * @param {?} el
     * @param {?} methodName
     * @param {?} args
     * @return {?}
     */
    BrowserDomAdapter.prototype.invoke = /**
     * @param {?} el
     * @param {?} methodName
     * @param {?} args
     * @return {?}
     */
    function (el, methodName, args) {
        (_a = (/** @type {?} */ (el)))[methodName].apply(_a, args);
        var _a;
    };
    // TODO(tbosch): move this into a separate environment class once we have it
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.logError = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        if (window.console) {
            if (console.error) {
                console.error(error);
            }
            else {
                console.log(error);
            }
        }
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.log = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        if (window.console) {
            window.console.log && window.console.log(error);
        }
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.logGroup = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        if (window.console) {
            window.console.group && window.console.group(error);
        }
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.logGroupEnd = /**
     * @return {?}
     */
    function () {
        if (window.console) {
            window.console.groupEnd && window.console.groupEnd();
        }
    };
    Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
        get: /**
         * @return {?}
         */
        function () { return _attrToPropMap; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} nodeA
     * @param {?} nodeB
     * @return {?}
     */
    BrowserDomAdapter.prototype.contains = /**
     * @param {?} nodeA
     * @param {?} nodeB
     * @return {?}
     */
    function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
    /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.querySelector = /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    function (el, selector) { return el.querySelector(selector); };
    /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.querySelectorAll = /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    function (el, selector) { return el.querySelectorAll(selector); };
    /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    BrowserDomAdapter.prototype.on = /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    function (el, evt, listener) { el.addEventListener(evt, listener, false); };
    /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    BrowserDomAdapter.prototype.onAndCancel = /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    function (el, evt, listener) {
        el.addEventListener(evt, listener, false);
        // Needed to follow Dart's subscription semantic, until fix of
        // https://code.google.com/p/dart/issues/detail?id=17406
        return function () { el.removeEventListener(evt, listener, false); };
    };
    /**
     * @param {?} el
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.dispatchEvent = /**
     * @param {?} el
     * @param {?} evt
     * @return {?}
     */
    function (el, evt) { el.dispatchEvent(evt); };
    /**
     * @param {?} eventType
     * @return {?}
     */
    BrowserDomAdapter.prototype.createMouseEvent = /**
     * @param {?} eventType
     * @return {?}
     */
    function (eventType) {
        var /** @type {?} */ evt = this.getDefaultDocument().createEvent('MouseEvent');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    /**
     * @param {?} eventType
     * @return {?}
     */
    BrowserDomAdapter.prototype.createEvent = /**
     * @param {?} eventType
     * @return {?}
     */
    function (eventType) {
        var /** @type {?} */ evt = this.getDefaultDocument().createEvent('Event');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.preventDefault = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        evt.preventDefault();
        evt.returnValue = false;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.isPrevented = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getInnerHTML = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.innerHTML; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getTemplateContent = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        return 'content' in el && this.isTemplateElement(el) ? (/** @type {?} */ (el)).content : null;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getOuterHTML = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.outerHTML; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.nodeName = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nodeName; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.nodeValue = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nodeValue; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.type = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.type; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.content = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        if (this.hasProperty(node, 'content')) {
            return (/** @type {?} */ (node)).content;
        }
        else {
            return node;
        }
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.firstChild = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.firstChild; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.nextSibling = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.nextSibling; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.parentElement = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.parentNode; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.childNodes = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.childNodes; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.childNodesAsList = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        var /** @type {?} */ childNodes = el.childNodes;
        var /** @type {?} */ res = new Array(childNodes.length);
        for (var /** @type {?} */ i = 0; i < childNodes.length; i++) {
            res[i] = childNodes[i];
        }
        return res;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.clearNodes = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    };
    /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.appendChild = /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    function (el, node) { el.appendChild(node); };
    /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeChild = /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    function (el, node) { el.removeChild(node); };
    /**
     * @param {?} el
     * @param {?} newChild
     * @param {?} oldChild
     * @return {?}
     */
    BrowserDomAdapter.prototype.replaceChild = /**
     * @param {?} el
     * @param {?} newChild
     * @param {?} oldChild
     * @return {?}
     */
    function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.remove = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
        return node;
    };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertBefore = /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    function (parent, ref, node) { parent.insertBefore(node, ref); };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} nodes
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertAllBefore = /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} nodes
     * @return {?}
     */
    function (parent, ref, nodes) {
        nodes.forEach(function (n) { return parent.insertBefore(n, ref); });
    };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertAfter = /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setInnerHTML = /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    function (el, value) { el.innerHTML = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getText = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.textContent; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setText = /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    function (el, value) { el.textContent = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getValue = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.value; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setValue = /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    function (el, value) { el.value = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getChecked = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return el.checked; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setChecked = /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    function (el, value) { el.checked = value; };
    /**
     * @param {?} text
     * @return {?}
     */
    BrowserDomAdapter.prototype.createComment = /**
     * @param {?} text
     * @return {?}
     */
    function (text) { return this.getDefaultDocument().createComment(text); };
    /**
     * @param {?} html
     * @return {?}
     */
    BrowserDomAdapter.prototype.createTemplate = /**
     * @param {?} html
     * @return {?}
     */
    function (html) {
        var /** @type {?} */ t = this.getDefaultDocument().createElement('template');
        t.innerHTML = html;
        return t;
    };
    /**
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createElement = /**
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    function (tagName, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createElement(tagName);
    };
    /**
     * @param {?} ns
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createElementNS = /**
     * @param {?} ns
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    function (ns, tagName, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createElementNS(ns, tagName);
    };
    /**
     * @param {?} text
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createTextNode = /**
     * @param {?} text
     * @param {?=} doc
     * @return {?}
     */
    function (text, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createTextNode(text);
    };
    /**
     * @param {?} attrName
     * @param {?} attrValue
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createScriptTag = /**
     * @param {?} attrName
     * @param {?} attrValue
     * @param {?=} doc
     * @return {?}
     */
    function (attrName, attrValue, doc) {
        doc = doc || this.getDefaultDocument();
        var /** @type {?} */ el = /** @type {?} */ (doc.createElement('SCRIPT'));
        el.setAttribute(attrName, attrValue);
        return el;
    };
    /**
     * @param {?} css
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createStyleElement = /**
     * @param {?} css
     * @param {?=} doc
     * @return {?}
     */
    function (css, doc) {
        doc = doc || this.getDefaultDocument();
        var /** @type {?} */ style = /** @type {?} */ (doc.createElement('style'));
        this.appendChild(style, this.createTextNode(css, doc));
        return style;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.createShadowRoot = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return (/** @type {?} */ (el)).createShadowRoot(); };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getShadowRoot = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return (/** @type {?} */ (el)).shadowRoot; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHost = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return (/** @type {?} */ (el)).host; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.clone = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.cloneNode(true); };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getElementsByClassName = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) {
        return element.getElementsByClassName(name);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getElementsByTagName = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) {
        return element.getElementsByTagName(name);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.classList = /**
     * @param {?} element
     * @return {?}
     */
    function (element) { return Array.prototype.slice.call(element.classList, 0); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.addClass = /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    function (element, className) { element.classList.add(className); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeClass = /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    function (element, className) { element.classList.remove(className); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasClass = /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    function (element, className) {
        return element.classList.contains(className);
    };
    /**
     * @param {?} element
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    BrowserDomAdapter.prototype.setStyle = /**
     * @param {?} element
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    function (element, styleName, styleValue) {
        element.style[styleName] = styleValue;
    };
    /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeStyle = /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    function (element, stylename) {
        // IE requires '' instead of null
        // see https://github.com/angular/angular/issues/7916
        element.style[stylename] = '';
    };
    /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    BrowserDomAdapter.prototype.getStyle = /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    function (element, stylename) { return element.style[stylename]; };
    /**
     * @param {?} element
     * @param {?} styleName
     * @param {?=} styleValue
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasStyle = /**
     * @param {?} element
     * @param {?} styleName
     * @param {?=} styleValue
     * @return {?}
     */
    function (element, styleName, styleValue) {
        var /** @type {?} */ value = this.getStyle(element, styleName) || '';
        return styleValue ? value == styleValue : value.length > 0;
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.tagName = /**
     * @param {?} element
     * @return {?}
     */
    function (element) { return element.tagName; };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.attributeMap = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ res = new Map();
        var /** @type {?} */ elAttrs = element.attributes;
        for (var /** @type {?} */ i = 0; i < elAttrs.length; i++) {
            var /** @type {?} */ attrib = elAttrs.item(i);
            res.set(attrib.name, attrib.value);
        }
        return res;
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasAttribute = /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    function (element, attribute) {
        return element.hasAttribute(attribute);
    };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasAttributeNS = /**
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    function (element, ns, attribute) {
        return element.hasAttributeNS(ns, attribute);
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.getAttribute = /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    function (element, attribute) {
        return element.getAttribute(attribute);
    };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getAttributeNS = /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    function (element, ns, name) {
        return element.getAttributeNS(ns, name);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setAttribute = /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (element, name, value) { element.setAttribute(name, value); };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setAttributeNS = /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (element, ns, name, value) {
        element.setAttributeNS(ns, name, value);
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeAttribute = /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    function (element, attribute) { element.removeAttribute(attribute); };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeAttributeNS = /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    function (element, ns, name) {
        element.removeAttributeNS(ns, name);
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.templateAwareRoot = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.createHtmlDocument = /**
     * @return {?}
     */
    function () {
        return document.implementation.createHTMLDocument('fakeTitle');
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getDefaultDocument = /**
     * @return {?}
     */
    function () { return document; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getBoundingClientRect = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        try {
            return el.getBoundingClientRect();
        }
        catch (/** @type {?} */ e) {
            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
        }
    };
    /**
     * @param {?} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.getTitle = /**
     * @param {?} doc
     * @return {?}
     */
    function (doc) { return doc.title; };
    /**
     * @param {?} doc
     * @param {?} newTitle
     * @return {?}
     */
    BrowserDomAdapter.prototype.setTitle = /**
     * @param {?} doc
     * @param {?} newTitle
     * @return {?}
     */
    function (doc, newTitle) { doc.title = newTitle || ''; };
    /**
     * @param {?} n
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.elementMatches = /**
     * @param {?} n
     * @param {?} selector
     * @return {?}
     */
    function (n, selector) {
        if (this.isElementNode(n)) {
            return n.matches && n.matches(selector) ||
                n.msMatchesSelector && n.msMatchesSelector(selector) ||
                n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
        }
        return false;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.isTemplateElement = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        return this.isElementNode(el) && el.nodeName === 'TEMPLATE';
    };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isTextNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nodeType === Node.TEXT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isCommentNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nodeType === Node.COMMENT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isElementNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasShadowRoot = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        return node.shadowRoot != null && node instanceof HTMLElement;
    };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isShadowRoot = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node instanceof DocumentFragment; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.importIntoDoc = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return document.importNode(this.templateAwareRoot(node), true); };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.adoptNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return document.adoptNode(node); };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHref = /**
     * @param {?} el
     * @return {?}
     */
    function (el) { return /** @type {?} */ ((el.getAttribute('href'))); };
    /**
     * @param {?} event
     * @return {?}
     */
    BrowserDomAdapter.prototype.getEventKey = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var /** @type {?} */ key = event.key;
        if (key == null) {
            key = event.keyIdentifier;
            // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
            // Safari cf
            // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
            if (key == null) {
                return 'Unidentified';
            }
            if (key.startsWith('U+')) {
                key = String.fromCharCode(parseInt(key.substring(2), 16));
                if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                    // There is a bug in Chrome for numeric keypad keys:
                    // https://code.google.com/p/chromium/issues/detail?id=155654
                    // 1, 2, 3 ... are reported as A, B, C ...
                    key = (/** @type {?} */ (_chromeNumKeyPadMap))[key];
                }
            }
        }
        return _keyMap[key] || key;
    };
    /**
     * @param {?} doc
     * @param {?} target
     * @return {?}
     */
    BrowserDomAdapter.prototype.getGlobalEventTarget = /**
     * @param {?} doc
     * @param {?} target
     * @return {?}
     */
    function (doc, target) {
        if (target === 'window') {
            return window;
        }
        if (target === 'document') {
            return doc;
        }
        if (target === 'body') {
            return doc.body;
        }
        return null;
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHistory = /**
     * @return {?}
     */
    function () { return window.history; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getLocation = /**
     * @return {?}
     */
    function () { return window.location; };
    /**
     * @param {?} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.getBaseHref = /**
     * @param {?} doc
     * @return {?}
     */
    function (doc) {
        var /** @type {?} */ href = getBaseElementHref();
        return href == null ? null : relativePath(href);
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.resetBaseElement = /**
     * @return {?}
     */
    function () { baseElement = null; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getUserAgent = /**
     * @return {?}
     */
    function () { return window.navigator.userAgent; };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setData = /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (element, name, value) {
        this.setAttribute(element, 'data-' + name, value);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getData = /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    function (element, name) {
        return this.getAttribute(element, 'data-' + name);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.getComputedStyle = /**
     * @param {?} element
     * @return {?}
     */
    function (element) { return getComputedStyle(element); };
    // TODO(tbosch): move this into a separate environment class once we have it
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.supportsWebAnimation = /**
     * @return {?}
     */
    function () {
        return typeof (/** @type {?} */ (Element)).prototype['animate'] === 'function';
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.performanceNow = /**
     * @return {?}
     */
    function () {
        // performance.now() is not available in all browsers, see
        // http://caniuse.com/#search=performance.now
        return window.performance && window.performance.now ? window.performance.now() :
            new Date().getTime();
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.supportsCookies = /**
     * @return {?}
     */
    function () { return true; };
    /**
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getCookie = /**
     * @param {?} name
     * @return {?}
     */
    function (name) { return common.ɵparseCookieValue(document.cookie, name); };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setCookie = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
        // not clear other cookies.
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    };
    return BrowserDomAdapter;
}(GenericBrowserDomAdapter));
var baseElement = null;
/**
 * @return {?}
 */
function getBaseElementHref() {
    if (!baseElement) {
        baseElement = /** @type {?} */ ((document.querySelector('base')));
        if (!baseElement) {
            return null;
        }
    }
    return baseElement.getAttribute('href');
}
// based on urlUtils.js in AngularJS 1
var urlParsingNode;
/**
 * @param {?} url
 * @return {?}
 */
function relativePath(url) {
    if (!urlParsingNode) {
        urlParsingNode = document.createElement('a');
    }
    urlParsingNode.setAttribute('href', url);
    return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
        '/' + urlParsingNode.pathname;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 * @deprecated import from `\@angular/common` instead.
 */
var DOCUMENT$1 = common.DOCUMENT;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function supportsState() {
    return !!window.history.pushState;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
 * This class should not be used directly by an application developer. Instead, use
 * {\@link Location}.
 */
var BrowserPlatformLocation = /** @class */ (function (_super) {
    __extends(BrowserPlatformLocation, _super);
    function BrowserPlatformLocation(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._init();
        return _this;
    }
    // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    BrowserPlatformLocation.prototype._init = /**
     * \@internal
     * @return {?}
     */
    function () {
        (/** @type {?} */ (this)).location = getDOM().getLocation();
        this._history = getDOM().getHistory();
    };
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.getBaseHrefFromDOM = /**
     * @return {?}
     */
    function () { return /** @type {?} */ ((getDOM().getBaseHref(this._doc))); };
    /**
     * @param {?} fn
     * @return {?}
     */
    BrowserPlatformLocation.prototype.onPopState = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BrowserPlatformLocation.prototype.onHashChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
        get: /**
         * @return {?}
         */
        function () { return this.location.pathname; },
        set: /**
         * @param {?} newPath
         * @return {?}
         */
        function (newPath) { this.location.pathname = newPath; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
        get: /**
         * @return {?}
         */
        function () { return this.location.search; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
        get: /**
         * @return {?}
         */
        function () { return this.location.hash; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    BrowserPlatformLocation.prototype.pushState = /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    function (state, title, url) {
        if (supportsState()) {
            this._history.pushState(state, title, url);
        }
        else {
            this.location.hash = url;
        }
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    BrowserPlatformLocation.prototype.replaceState = /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    function (state, title, url) {
        if (supportsState()) {
            this._history.replaceState(state, title, url);
        }
        else {
            this.location.hash = url;
        }
    };
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.forward = /**
     * @return {?}
     */
    function () { this._history.forward(); };
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.back = /**
     * @return {?}
     */
    function () { this._history.back(); };
    BrowserPlatformLocation.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    BrowserPlatformLocation.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return BrowserPlatformLocation;
}(common.PlatformLocation));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A service that can be used to get and add meta tags.
 *
 * \@experimental
 */
var Meta = /** @class */ (function () {
    function Meta(_doc) {
        this._doc = _doc;
        this._dom = getDOM();
    }
    /**
     * @param {?} tag
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype.addTag = /**
     * @param {?} tag
     * @param {?=} forceCreation
     * @return {?}
     */
    function (tag, forceCreation) {
        if (forceCreation === void 0) { forceCreation = false; }
        if (!tag)
            return null;
        return this._getOrCreateElement(tag, forceCreation);
    };
    /**
     * @param {?} tags
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype.addTags = /**
     * @param {?} tags
     * @param {?=} forceCreation
     * @return {?}
     */
    function (tags, forceCreation) {
        var _this = this;
        if (forceCreation === void 0) { forceCreation = false; }
        if (!tags)
            return [];
        return tags.reduce(function (result, tag) {
            if (tag) {
                result.push(_this._getOrCreateElement(tag, forceCreation));
            }
            return result;
        }, []);
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.getTag = /**
     * @param {?} attrSelector
     * @return {?}
     */
    function (attrSelector) {
        if (!attrSelector)
            return null;
        return this._dom.querySelector(this._doc, "meta[" + attrSelector + "]") || null;
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.getTags = /**
     * @param {?} attrSelector
     * @return {?}
     */
    function (attrSelector) {
        if (!attrSelector)
            return [];
        var /** @type {?} */ list = this._dom.querySelectorAll(this._doc, "meta[" + attrSelector + "]");
        return list ? [].slice.call(list) : [];
    };
    /**
     * @param {?} tag
     * @param {?=} selector
     * @return {?}
     */
    Meta.prototype.updateTag = /**
     * @param {?} tag
     * @param {?=} selector
     * @return {?}
     */
    function (tag, selector) {
        if (!tag)
            return null;
        selector = selector || this._parseSelector(tag);
        var /** @type {?} */ meta = /** @type {?} */ ((this.getTag(selector)));
        if (meta) {
            return this._setMetaElementAttributes(tag, meta);
        }
        return this._getOrCreateElement(tag, true);
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.removeTag = /**
     * @param {?} attrSelector
     * @return {?}
     */
    function (attrSelector) { this.removeTagElement(/** @type {?} */ ((this.getTag(attrSelector)))); };
    /**
     * @param {?} meta
     * @return {?}
     */
    Meta.prototype.removeTagElement = /**
     * @param {?} meta
     * @return {?}
     */
    function (meta) {
        if (meta) {
            this._dom.remove(meta);
        }
    };
    /**
     * @param {?} meta
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype._getOrCreateElement = /**
     * @param {?} meta
     * @param {?=} forceCreation
     * @return {?}
     */
    function (meta, forceCreation) {
        if (forceCreation === void 0) { forceCreation = false; }
        if (!forceCreation) {
            var /** @type {?} */ selector = this._parseSelector(meta);
            var /** @type {?} */ elem = /** @type {?} */ ((this.getTag(selector)));
            // It's allowed to have multiple elements with the same name so it's not enough to
            // just check that element with the same name already present on the page. We also need to
            // check if element has tag attributes
            if (elem && this._containsAttributes(meta, elem))
                return elem;
        }
        var /** @type {?} */ element = /** @type {?} */ (this._dom.createElement('meta'));
        this._setMetaElementAttributes(meta, element);
        var /** @type {?} */ head = this._dom.getElementsByTagName(this._doc, 'head')[0];
        this._dom.appendChild(head, element);
        return element;
    };
    /**
     * @param {?} tag
     * @param {?} el
     * @return {?}
     */
    Meta.prototype._setMetaElementAttributes = /**
     * @param {?} tag
     * @param {?} el
     * @return {?}
     */
    function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    Meta.prototype._parseSelector = /**
     * @param {?} tag
     * @return {?}
     */
    function (tag) {
        var /** @type {?} */ attr = tag.name ? 'name' : 'property';
        return attr + "=\"" + tag[attr] + "\"";
    };
    /**
     * @param {?} tag
     * @param {?} elem
     * @return {?}
     */
    Meta.prototype._containsAttributes = /**
     * @param {?} tag
     * @param {?} elem
     * @return {?}
     */
    function (tag, elem) {
        var _this = this;
        return Object.keys(tag).every(function (key) { return _this._dom.getAttribute(elem, key) === tag[key]; });
    };
    Meta.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    Meta.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return Meta;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An id that identifies a particular application being bootstrapped, that should
 * match across the client/server boundary.
 */
var TRANSITION_ID = new core.InjectionToken('TRANSITION_ID');
/**
 * @param {?} transitionId
 * @param {?} document
 * @param {?} injector
 * @return {?}
 */
function appInitializerFactory(transitionId, document, injector) {
    return function () {
        // Wait for all application initializers to be completed before removing the styles set by
        // the server.
        injector.get(core.ApplicationInitStatus).donePromise.then(function () {
            var /** @type {?} */ dom = getDOM();
            var /** @type {?} */ styles = Array.prototype.slice.apply(dom.querySelectorAll(document, "style[ng-transition]"));
            styles.filter(function (el) { return dom.getAttribute(el, 'ng-transition') === transitionId; })
                .forEach(function (el) { return dom.remove(el); });
        });
    };
}
var SERVER_TRANSITION_PROVIDERS = [
    {
        provide: core.APP_INITIALIZER,
        useFactory: appInitializerFactory,
        deps: [TRANSITION_ID, DOCUMENT$1, core.Injector],
        multi: true
    },
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BrowserGetTestability = /** @class */ (function () {
    function BrowserGetTestability() {
    }
    /**
     * @return {?}
     */
    BrowserGetTestability.init = /**
     * @return {?}
     */
    function () { core.setTestabilityGetter(new BrowserGetTestability()); };
    /**
     * @param {?} registry
     * @return {?}
     */
    BrowserGetTestability.prototype.addToWindow = /**
     * @param {?} registry
     * @return {?}
     */
    function (registry) {
        core.ɵglobal['getAngularTestability'] = function (elem, findInAncestors) {
            if (findInAncestors === void 0) { findInAncestors = true; }
            var /** @type {?} */ testability = registry.findTestabilityInTree(elem, findInAncestors);
            if (testability == null) {
                throw new Error('Could not find testability for element.');
            }
            return testability;
        };
        core.ɵglobal['getAllAngularTestabilities'] = function () { return registry.getAllTestabilities(); };
        core.ɵglobal['getAllAngularRootElements'] = function () { return registry.getAllRootElements(); };
        var /** @type {?} */ whenAllStable = function (callback /** TODO #9100 */) {
            var /** @type {?} */ testabilities = core.ɵglobal['getAllAngularTestabilities']();
            var /** @type {?} */ count = testabilities.length;
            var /** @type {?} */ didWork = false;
            var /** @type {?} */ decrement = function (didWork_ /** TODO #9100 */) {
                didWork = didWork || didWork_;
                count--;
                if (count == 0) {
                    callback(didWork);
                }
            };
            testabilities.forEach(function (testability /** TODO #9100 */) {
                testability.whenStable(decrement);
            });
        };
        if (!core.ɵglobal['frameworkStabilizers']) {
            core.ɵglobal['frameworkStabilizers'] = [];
        }
        core.ɵglobal['frameworkStabilizers'].push(whenAllStable);
    };
    /**
     * @param {?} registry
     * @param {?} elem
     * @param {?} findInAncestors
     * @return {?}
     */
    BrowserGetTestability.prototype.findTestabilityInTree = /**
     * @param {?} registry
     * @param {?} elem
     * @param {?} findInAncestors
     * @return {?}
     */
    function (registry, elem, findInAncestors) {
        if (elem == null) {
            return null;
        }
        var /** @type {?} */ t = registry.getTestability(elem);
        if (t != null) {
            return t;
        }
        else if (!findInAncestors) {
            return null;
        }
        if (getDOM().isShadowRoot(elem)) {
            return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
        }
        return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
    };
    return BrowserGetTestability;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A service that can be used to get and set the title of a current HTML document.
 *
 * Since an Angular application can't be bootstrapped on the entire HTML document (`<html>` tag)
 * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
 * (representing the `<title>` tag). Instead, this service can be used to set and get the current
 * title value.
 *
 * \@experimental
 */
var Title = /** @class */ (function () {
    function Title(_doc) {
        this._doc = _doc;
    }
    /**
     * Get the title of the current HTML document.
     */
    /**
     * Get the title of the current HTML document.
     * @return {?}
     */
    Title.prototype.getTitle = /**
     * Get the title of the current HTML document.
     * @return {?}
     */
    function () { return getDOM().getTitle(this._doc); };
    /**
     * Set the title of the current HTML document.
     * @param newTitle
     */
    /**
     * Set the title of the current HTML document.
     * @param {?} newTitle
     * @return {?}
     */
    Title.prototype.setTitle = /**
     * Set the title of the current HTML document.
     * @param {?} newTitle
     * @return {?}
     */
    function (newTitle) { getDOM().setTitle(this._doc, newTitle); };
    Title.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    Title.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return Title;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} input
 * @return {?}
 */

/**
 * @param {?} input
 * @return {?}
 */

/**
 * Exports the value under a given `name` in the global property `ng`. For example `ng.probe` if
 * `name` is `'probe'`.
 * @param {?} name Name under which it will be exported. Keep in mind this will be a property of the
 * global `ng` object.
 * @param {?} value The value to export.
 * @return {?}
 */
function exportNgVar(name, value) {
    if (typeof COMPILED === 'undefined' || !COMPILED) {
        // Note: we can't export `ng` when using closure enhanced optimization as:
        // - closure declares globals itself for minified names, which sometimes clobber our `ng` global
        // - we can't declare a closure extern as the namespace `ng` is already used within Google
        //   for typings for angularJS (via `goog.provide('ng....')`).
        var /** @type {?} */ ng = core.ɵglobal['ng'] = (/** @type {?} */ (core.ɵglobal['ng'])) || {};
        ng[name] = value;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CORE_TOKENS = {
    'ApplicationRef': core.ApplicationRef,
    'NgZone': core.NgZone,
};
var INSPECT_GLOBAL_NAME = 'probe';
var CORE_TOKENS_GLOBAL_NAME = 'coreTokens';
/**
 * Returns a {\@link DebugElement} for the given native DOM element, or
 * null if the given native element does not have an Angular view associated
 * with it.
 * @param {?} element
 * @return {?}
 */
function inspectNativeElement(element) {
    return core.getDebugNode(element);
}
/**
 * @param {?} coreTokens
 * @return {?}
 */
function _createNgProbe(coreTokens) {
    exportNgVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
    exportNgVar(CORE_TOKENS_GLOBAL_NAME, __assign({}, CORE_TOKENS, _ngProbeTokensToMap(coreTokens || [])));
    return function () { return inspectNativeElement; };
}
/**
 * @param {?} tokens
 * @return {?}
 */
function _ngProbeTokensToMap(tokens) {
    return tokens.reduce(function (prev, t) { return (prev[t.name] = t.token, prev); }, {});
}
/**
 * Providers which support debugging Angular applications (e.g. via `ng.probe`).
 */
var ELEMENT_PROBE_PROVIDERS = [
    {
        provide: core.APP_INITIALIZER,
        useFactory: _createNgProbe,
        deps: [
            [core.NgProbeToken, new core.Optional()],
        ],
        multi: true,
    },
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var EVENT_MANAGER_PLUGINS = new core.InjectionToken('EventManagerPlugins');
/**
 * \@stable
 */
var EventManager = /** @class */ (function () {
    function EventManager(plugins, _zone) {
        var _this = this;
        this._zone = _zone;
        this._eventNameToPlugin = new Map();
        plugins.forEach(function (p) { return p.manager = _this; });
        this._plugins = plugins.slice().reverse();
    }
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManager.prototype.addEventListener = /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (element, eventName, handler) {
        var /** @type {?} */ plugin = this._findPluginFor(eventName);
        return plugin.addEventListener(element, eventName, handler);
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManager.prototype.addGlobalEventListener = /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (target, eventName, handler) {
        var /** @type {?} */ plugin = this._findPluginFor(eventName);
        return plugin.addGlobalEventListener(target, eventName, handler);
    };
    /**
     * @return {?}
     */
    EventManager.prototype.getZone = /**
     * @return {?}
     */
    function () { return this._zone; };
    /** @internal */
    /**
     * \@internal
     * @param {?} eventName
     * @return {?}
     */
    EventManager.prototype._findPluginFor = /**
     * \@internal
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) {
        var /** @type {?} */ plugin = this._eventNameToPlugin.get(eventName);
        if (plugin) {
            return plugin;
        }
        var /** @type {?} */ plugins = this._plugins;
        for (var /** @type {?} */ i = 0; i < plugins.length; i++) {
            var /** @type {?} */ plugin_1 = plugins[i];
            if (plugin_1.supports(eventName)) {
                this._eventNameToPlugin.set(eventName, plugin_1);
                return plugin_1;
            }
        }
        throw new Error("No event manager plugin found for event " + eventName);
    };
    EventManager.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    EventManager.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: core.Inject, args: [EVENT_MANAGER_PLUGINS,] },] },
        { type: core.NgZone, },
    ]; };
    return EventManager;
}());
/**
 * @abstract
 */
var EventManagerPlugin = /** @class */ (function () {
    function EventManagerPlugin(_doc) {
        this._doc = _doc;
    }
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManagerPlugin.prototype.addGlobalEventListener = /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (element, eventName, handler) {
        var /** @type {?} */ target = getDOM().getGlobalEventTarget(this._doc, element);
        if (!target) {
            throw new Error("Unsupported event target " + target + " for event " + eventName);
        }
        return this.addEventListener(target, eventName, handler);
    };
    return EventManagerPlugin;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SharedStylesHost = /** @class */ (function () {
    function SharedStylesHost() {
        /**
         * \@internal
         */
        this._stylesSet = new Set();
    }
    /**
     * @param {?} styles
     * @return {?}
     */
    SharedStylesHost.prototype.addStyles = /**
     * @param {?} styles
     * @return {?}
     */
    function (styles) {
        var _this = this;
        var /** @type {?} */ additions = new Set();
        styles.forEach(function (style) {
            if (!_this._stylesSet.has(style)) {
                _this._stylesSet.add(style);
                additions.add(style);
            }
        });
        this.onStylesAdded(additions);
    };
    /**
     * @param {?} additions
     * @return {?}
     */
    SharedStylesHost.prototype.onStylesAdded = /**
     * @param {?} additions
     * @return {?}
     */
    function (additions) { };
    /**
     * @return {?}
     */
    SharedStylesHost.prototype.getAllStyles = /**
     * @return {?}
     */
    function () { return Array.from(this._stylesSet); };
    SharedStylesHost.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    SharedStylesHost.ctorParameters = function () { return []; };
    return SharedStylesHost;
}());
var DomSharedStylesHost = /** @class */ (function (_super) {
    __extends(DomSharedStylesHost, _super);
    function DomSharedStylesHost(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._hostNodes = new Set();
        _this._styleNodes = new Set();
        _this._hostNodes.add(_doc.head);
        return _this;
    }
    /**
     * @param {?} styles
     * @param {?} host
     * @return {?}
     */
    DomSharedStylesHost.prototype._addStylesToHost = /**
     * @param {?} styles
     * @param {?} host
     * @return {?}
     */
    function (styles, host) {
        var _this = this;
        styles.forEach(function (style) {
            var /** @type {?} */ styleEl = _this._doc.createElement('style');
            styleEl.textContent = style;
            _this._styleNodes.add(host.appendChild(styleEl));
        });
    };
    /**
     * @param {?} hostNode
     * @return {?}
     */
    DomSharedStylesHost.prototype.addHost = /**
     * @param {?} hostNode
     * @return {?}
     */
    function (hostNode) {
        this._addStylesToHost(this._stylesSet, hostNode);
        this._hostNodes.add(hostNode);
    };
    /**
     * @param {?} hostNode
     * @return {?}
     */
    DomSharedStylesHost.prototype.removeHost = /**
     * @param {?} hostNode
     * @return {?}
     */
    function (hostNode) { this._hostNodes.delete(hostNode); };
    /**
     * @param {?} additions
     * @return {?}
     */
    DomSharedStylesHost.prototype.onStylesAdded = /**
     * @param {?} additions
     * @return {?}
     */
    function (additions) {
        var _this = this;
        this._hostNodes.forEach(function (hostNode) { return _this._addStylesToHost(additions, hostNode); });
    };
    /**
     * @return {?}
     */
    DomSharedStylesHost.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { this._styleNodes.forEach(function (styleNode) { return getDOM().remove(styleNode); }); };
    DomSharedStylesHost.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    DomSharedStylesHost.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return DomSharedStylesHost;
}(SharedStylesHost));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NAMESPACE_URIS = {
    'svg': 'http://www.w3.org/2000/svg',
    'xhtml': 'http://www.w3.org/1999/xhtml',
    'xlink': 'http://www.w3.org/1999/xlink',
    'xml': 'http://www.w3.org/XML/1998/namespace',
    'xmlns': 'http://www.w3.org/2000/xmlns/',
};
var COMPONENT_REGEX = /%COMP%/g;
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
/**
 * @param {?} componentShortId
 * @return {?}
 */
function shimContentAttribute(componentShortId) {
    return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
/**
 * @param {?} componentShortId
 * @return {?}
 */
function shimHostAttribute(componentShortId) {
    return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
/**
 * @param {?} compId
 * @param {?} styles
 * @param {?} target
 * @return {?}
 */
function flattenStyles(compId, styles, target) {
    for (var /** @type {?} */ i = 0; i < styles.length; i++) {
        var /** @type {?} */ style = styles[i];
        if (Array.isArray(style)) {
            flattenStyles(compId, style, target);
        }
        else {
            style = style.replace(COMPONENT_REGEX, compId);
            target.push(style);
        }
    }
    return target;
}
/**
 * @param {?} eventHandler
 * @return {?}
 */
function decoratePreventDefault(eventHandler) {
    return function (event) {
        var /** @type {?} */ allowDefaultBehavior = eventHandler(event);
        if (allowDefaultBehavior === false) {
            // TODO(tbosch): move preventDefault into event plugins...
            event.preventDefault();
            event.returnValue = false;
        }
    };
}
var DomRendererFactory2 = /** @class */ (function () {
    function DomRendererFactory2(eventManager, sharedStylesHost) {
        this.eventManager = eventManager;
        this.sharedStylesHost = sharedStylesHost;
        this.rendererByCompId = new Map();
        this.defaultRenderer = new DefaultDomRenderer2(eventManager);
    }
    /**
     * @param {?} element
     * @param {?} type
     * @return {?}
     */
    DomRendererFactory2.prototype.createRenderer = /**
     * @param {?} element
     * @param {?} type
     * @return {?}
     */
    function (element, type) {
        if (!element || !type) {
            return this.defaultRenderer;
        }
        switch (type.encapsulation) {
            case core.ViewEncapsulation.Emulated: {
                var /** @type {?} */ renderer = this.rendererByCompId.get(type.id);
                if (!renderer) {
                    renderer =
                        new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type);
                    this.rendererByCompId.set(type.id, renderer);
                }
                (/** @type {?} */ (renderer)).applyToHost(element);
                return renderer;
            }
            case core.ViewEncapsulation.Native:
                return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
            default: {
                if (!this.rendererByCompId.has(type.id)) {
                    var /** @type {?} */ styles = flattenStyles(type.id, type.styles, []);
                    this.sharedStylesHost.addStyles(styles);
                    this.rendererByCompId.set(type.id, this.defaultRenderer);
                }
                return this.defaultRenderer;
            }
        }
    };
    /**
     * @return {?}
     */
    DomRendererFactory2.prototype.begin = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    DomRendererFactory2.prototype.end = /**
     * @return {?}
     */
    function () { };
    DomRendererFactory2.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    DomRendererFactory2.ctorParameters = function () { return [
        { type: EventManager, },
        { type: DomSharedStylesHost, },
    ]; };
    return DomRendererFactory2;
}());
var DefaultDomRenderer2 = /** @class */ (function () {
    function DefaultDomRenderer2(eventManager) {
        this.eventManager = eventManager;
        this.data = Object.create(null);
    }
    /**
     * @return {?}
     */
    DefaultDomRenderer2.prototype.destroy = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createElement = /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    function (name, namespace) {
        if (namespace) {
            return document.createElementNS(NAMESPACE_URIS[namespace], name);
        }
        return document.createElement(name);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createComment = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return document.createComment(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createText = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return document.createTextNode(value); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.appendChild = /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    function (parent, newChild) { parent.appendChild(newChild); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.insertBefore = /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    function (parent, newChild, refChild) {
        if (parent) {
            parent.insertBefore(newChild, refChild);
        }
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeChild = /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    function (parent, oldChild) {
        if (parent) {
            parent.removeChild(oldChild);
        }
    };
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    DefaultDomRenderer2.prototype.selectRootElement = /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    function (selectorOrNode) {
        var /** @type {?} */ el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
            selectorOrNode;
        if (!el) {
            throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
        }
        el.textContent = '';
        return el;
    };
    /**
     * @param {?} node
     * @return {?}
     */
    DefaultDomRenderer2.prototype.parentNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.parentNode; };
    /**
     * @param {?} node
     * @return {?}
     */
    DefaultDomRenderer2.prototype.nextSibling = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node.nextSibling; };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setAttribute = /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    function (el, name, value, namespace) {
        if (namespace) {
            name = namespace + ":" + name;
            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.setAttributeNS(namespaceUri, name, value);
            }
            else {
                el.setAttribute(name, value);
            }
        }
        else {
            el.setAttribute(name, value);
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeAttribute = /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    function (el, name, namespace) {
        if (namespace) {
            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.removeAttributeNS(namespaceUri, name);
            }
            else {
                el.removeAttribute(namespace + ":" + name);
            }
        }
        else {
            el.removeAttribute(name);
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DefaultDomRenderer2.prototype.addClass = /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    function (el, name) { el.classList.add(name); };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeClass = /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    function (el, name) { el.classList.remove(name); };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?} flags
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setStyle = /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?} flags
     * @return {?}
     */
    function (el, style, value, flags) {
        if (flags & core.RendererStyleFlags2.DashCase) {
            el.style.setProperty(style, value, !!(flags & core.RendererStyleFlags2.Important) ? 'important' : '');
        }
        else {
            el.style[style] = value;
        }
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} flags
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeStyle = /**
     * @param {?} el
     * @param {?} style
     * @param {?} flags
     * @return {?}
     */
    function (el, style, flags) {
        if (flags & core.RendererStyleFlags2.DashCase) {
            el.style.removeProperty(style);
        }
        else {
            // IE requires '' instead of null
            // see https://github.com/angular/angular/issues/7916
            el.style[style] = '';
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setProperty = /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (el, name, value) {
        checkNoSyntheticProp(name, 'property');
        el[name] = value;
    };
    /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setValue = /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    function (node, value) { node.nodeValue = value; };
    /**
     * @param {?} target
     * @param {?} event
     * @param {?} callback
     * @return {?}
     */
    DefaultDomRenderer2.prototype.listen = /**
     * @param {?} target
     * @param {?} event
     * @param {?} callback
     * @return {?}
     */
    function (target, event, callback) {
        checkNoSyntheticProp(event, 'listener');
        if (typeof target === 'string') {
            return /** @type {?} */ (this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback)));
        }
        return /** @type {?} */ ((this.eventManager.addEventListener(target, event, decoratePreventDefault(callback))));
    };
    return DefaultDomRenderer2;
}());
var AT_CHARCODE = '@'.charCodeAt(0);
/**
 * @param {?} name
 * @param {?} nameKind
 * @return {?}
 */
function checkNoSyntheticProp(name, nameKind) {
    if (name.charCodeAt(0) === AT_CHARCODE) {
        throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
    }
}
var EmulatedEncapsulationDomRenderer2 = /** @class */ (function (_super) {
    __extends(EmulatedEncapsulationDomRenderer2, _super);
    function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.component = component;
        var /** @type {?} */ styles = flattenStyles(component.id, component.styles, []);
        sharedStylesHost.addStyles(styles);
        _this.contentAttr = shimContentAttribute(component.id);
        _this.hostAttr = shimHostAttribute(component.id);
        return _this;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    EmulatedEncapsulationDomRenderer2.prototype.applyToHost = /**
     * @param {?} element
     * @return {?}
     */
    function (element) { _super.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
    /**
     * @param {?} parent
     * @param {?} name
     * @return {?}
     */
    EmulatedEncapsulationDomRenderer2.prototype.createElement = /**
     * @param {?} parent
     * @param {?} name
     * @return {?}
     */
    function (parent, name) {
        var /** @type {?} */ el = _super.prototype.createElement.call(this, parent, name);
        _super.prototype.setAttribute.call(this, el, this.contentAttr, '');
        return el;
    };
    return EmulatedEncapsulationDomRenderer2;
}(DefaultDomRenderer2));
var ShadowDomRenderer = /** @class */ (function (_super) {
    __extends(ShadowDomRenderer, _super);
    function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.sharedStylesHost = sharedStylesHost;
        _this.hostEl = hostEl;
        _this.component = component;
        _this.shadowRoot = (/** @type {?} */ (hostEl)).createShadowRoot();
        _this.sharedStylesHost.addHost(_this.shadowRoot);
        var /** @type {?} */ styles = flattenStyles(component.id, component.styles, []);
        for (var /** @type {?} */ i = 0; i < styles.length; i++) {
            var /** @type {?} */ styleEl = document.createElement('style');
            styleEl.textContent = styles[i];
            _this.shadowRoot.appendChild(styleEl);
        }
        return _this;
    }
    /**
     * @param {?} node
     * @return {?}
     */
    ShadowDomRenderer.prototype.nodeOrShadowRoot = /**
     * @param {?} node
     * @return {?}
     */
    function (node) { return node === this.hostEl ? this.shadowRoot : node; };
    /**
     * @return {?}
     */
    ShadowDomRenderer.prototype.destroy = /**
     * @return {?}
     */
    function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.appendChild = /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    function (parent, newChild) {
        return _super.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.insertBefore = /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    function (parent, newChild, refChild) {
        return _super.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.removeChild = /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    function (parent, oldChild) {
        return _super.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    ShadowDomRenderer.prototype.parentNode = /**
     * @param {?} node
     * @return {?}
     */
    function (node) {
        return this.nodeOrShadowRoot(_super.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
    };
    return ShadowDomRenderer;
}(DefaultDomRenderer2));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ɵ0 = function (v) {
    return '__zone_symbol__' + v;
};
/**
 * Detect if Zone is present. If it is then use simple zone aware 'addEventListener'
 * since Angular can do much more
 * efficient bookkeeping than Zone can, because we have additional information. This speeds up
 * addEventListener by 3x.
 */
var __symbol__ = (typeof Zone !== 'undefined') && (/** @type {?} */ (Zone))['__symbol__'] || ɵ0;
var ADD_EVENT_LISTENER = __symbol__('addEventListener');
var REMOVE_EVENT_LISTENER = __symbol__('removeEventListener');
var symbolNames = {};
var FALSE = 'FALSE';
var ANGULAR = 'ANGULAR';
var NATIVE_ADD_LISTENER = 'addEventListener';
var NATIVE_REMOVE_LISTENER = 'removeEventListener';
// use the same symbol string which is used in zone.js
var stopSymbol = '__zone_symbol__propagationStopped';
var stopMethodSymbol = '__zone_symbol__stopImmediatePropagation';
var blackListedEvents = (typeof Zone !== 'undefined') && (/** @type {?} */ (Zone))[__symbol__('BLACK_LISTED_EVENTS')];
var blackListedMap;
if (blackListedEvents) {
    blackListedMap = {};
    blackListedEvents.forEach(function (eventName) { blackListedMap[eventName] = eventName; });
}
var isBlackListedEvent = function (eventName) {
    if (!blackListedMap) {
        return false;
    }
    return blackListedMap.hasOwnProperty(eventName);
};
// a global listener to handle all dom event,
// so we do not need to create a closure everytime
var globalListener = function (event) {
    var /** @type {?} */ symbolName = symbolNames[event.type];
    if (!symbolName) {
        return;
    }
    var /** @type {?} */ taskDatas = this[symbolName];
    if (!taskDatas) {
        return;
    }
    var /** @type {?} */ args = [event];
    if (taskDatas.length === 1) {
        // if taskDatas only have one element, just invoke it
        var /** @type {?} */ taskData = taskDatas[0];
        if (taskData.zone !== Zone.current) {
            // only use Zone.run when Zone.current not equals to stored zone
            return taskData.zone.run(taskData.handler, this, args);
        }
        else {
            return taskData.handler.apply(this, args);
        }
    }
    else {
        // copy tasks as a snapshot to avoid event handlers remove
        // itself or others
        var /** @type {?} */ copiedTasks = taskDatas.slice();
        for (var /** @type {?} */ i = 0; i < copiedTasks.length; i++) {
            // if other listener call event.stopImmediatePropagation
            // just break
            if ((/** @type {?} */ (event))[stopSymbol] === true) {
                break;
            }
            var /** @type {?} */ taskData = copiedTasks[i];
            if (taskData.zone !== Zone.current) {
                // only use Zone.run when Zone.current not equals to stored zone
                taskData.zone.run(taskData.handler, this, args);
            }
            else {
                taskData.handler.apply(this, args);
            }
        }
    }
};
var DomEventsPlugin = /** @class */ (function (_super) {
    __extends(DomEventsPlugin, _super);
    function DomEventsPlugin(doc, ngZone) {
        var _this = _super.call(this, doc) || this;
        _this.ngZone = ngZone;
        _this.patchEvent();
        return _this;
    }
    /**
     * @return {?}
     */
    DomEventsPlugin.prototype.patchEvent = /**
     * @return {?}
     */
    function () {
        if (!Event || !Event.prototype) {
            return;
        }
        if ((/** @type {?} */ (Event.prototype))[stopMethodSymbol]) {
            // already patched by zone.js
            return;
        }
        var /** @type {?} */ delegate = (/** @type {?} */ (Event.prototype))[stopMethodSymbol] =
            Event.prototype.stopImmediatePropagation;
        Event.prototype.stopImmediatePropagation = function () {
            if (this) {
                this[stopSymbol] = true;
            }
            // should call native delegate in case
            // in some enviroment part of the application
            // will not use the patched Event
            delegate && delegate.apply(this, arguments);
        };
    };
    // This plugin should come last in the list of plugins, because it accepts all
    // events.
    /**
     * @param {?} eventName
     * @return {?}
     */
    DomEventsPlugin.prototype.supports = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) { return true; };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    DomEventsPlugin.prototype.addEventListener = /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (element, eventName, handler) {
        var _this = this;
        /**
         * This code is about to add a listener to the DOM. If Zone.js is present, than
         * `addEventListener` has been patched. The patched code adds overhead in both
         * memory and speed (3x slower) than native. For this reason if we detect that
         * Zone.js is present we use a simple version of zone aware addEventListener instead.
         * The result is faster registration and the zone will be restored.
         * But ZoneSpec.onScheduleTask, ZoneSpec.onInvokeTask, ZoneSpec.onCancelTask
         * will not be invoked
         * We also do manual zone restoration in element.ts renderEventHandlerClosure method.
         *
         * NOTE: it is possible that the element is from different iframe, and so we
         * have to check before we execute the method.
         */
        var /** @type {?} */ zoneJsLoaded = element[ADD_EVENT_LISTENER];
        var /** @type {?} */ callback = /** @type {?} */ (handler);
        // if zonejs is loaded and current zone is not ngZone
        // we keep Zone.current on target for later restoration.
        if (zoneJsLoaded && (!core.NgZone.isInAngularZone() || isBlackListedEvent(eventName))) {
            var /** @type {?} */ symbolName = symbolNames[eventName];
            if (!symbolName) {
                symbolName = symbolNames[eventName] = __symbol__(ANGULAR + eventName + FALSE);
            }
            var /** @type {?} */ taskDatas = (/** @type {?} */ (element))[symbolName];
            var /** @type {?} */ globalListenerRegistered = taskDatas && taskDatas.length > 0;
            if (!taskDatas) {
                taskDatas = (/** @type {?} */ (element))[symbolName] = [];
            }
            var /** @type {?} */ zone = isBlackListedEvent(eventName) ? Zone.root : Zone.current;
            if (taskDatas.length === 0) {
                taskDatas.push({ zone: zone, handler: callback });
            }
            else {
                var /** @type {?} */ callbackRegistered = false;
                for (var /** @type {?} */ i = 0; i < taskDatas.length; i++) {
                    if (taskDatas[i].handler === callback) {
                        callbackRegistered = true;
                        break;
                    }
                }
                if (!callbackRegistered) {
                    taskDatas.push({ zone: zone, handler: callback });
                }
            }
            if (!globalListenerRegistered) {
                element[ADD_EVENT_LISTENER](eventName, globalListener, false);
            }
        }
        else {
            element[NATIVE_ADD_LISTENER](eventName, callback, false);
        }
        return function () { return _this.removeEventListener(element, eventName, callback); };
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    DomEventsPlugin.prototype.removeEventListener = /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    function (target, eventName, callback) {
        var /** @type {?} */ underlyingRemove = target[REMOVE_EVENT_LISTENER];
        // zone.js not loaded, use native removeEventListener
        if (!underlyingRemove) {
            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
        var /** @type {?} */ symbolName = symbolNames[eventName];
        var /** @type {?} */ taskDatas = symbolName && target[symbolName];
        if (!taskDatas) {
            // addEventListener not using patched version
            // just call native removeEventListener
            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
        // fix issue 20532, should be able to remove
        // listener which was added inside of ngZone
        var /** @type {?} */ found = false;
        for (var /** @type {?} */ i = 0; i < taskDatas.length; i++) {
            // remove listener from taskDatas if the callback equals
            if (taskDatas[i].handler === callback) {
                found = true;
                taskDatas.splice(i, 1);
                break;
            }
        }
        if (found) {
            if (taskDatas.length === 0) {
                // all listeners are removed, we can remove the globalListener from target
                underlyingRemove.apply(target, [eventName, globalListener, false]);
            }
        }
        else {
            // not found in taskDatas, the callback may be added inside of ngZone
            // use native remove listener to remove the calback
            target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
    };
    DomEventsPlugin.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    DomEventsPlugin.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        { type: core.NgZone, },
    ]; };
    return DomEventsPlugin;
}(EventManagerPlugin));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EVENT_NAMES = {
    // pan
    'pan': true,
    'panstart': true,
    'panmove': true,
    'panend': true,
    'pancancel': true,
    'panleft': true,
    'panright': true,
    'panup': true,
    'pandown': true,
    // pinch
    'pinch': true,
    'pinchstart': true,
    'pinchmove': true,
    'pinchend': true,
    'pinchcancel': true,
    'pinchin': true,
    'pinchout': true,
    // press
    'press': true,
    'pressup': true,
    // rotate
    'rotate': true,
    'rotatestart': true,
    'rotatemove': true,
    'rotateend': true,
    'rotatecancel': true,
    // swipe
    'swipe': true,
    'swipeleft': true,
    'swiperight': true,
    'swipeup': true,
    'swipedown': true,
    // tap
    'tap': true,
};
/**
 * A DI token that you can use to provide{\@link HammerGestureConfig} to Angular. Use it to configure
 * Hammer gestures.
 *
 * \@experimental
 */
var HAMMER_GESTURE_CONFIG = new core.InjectionToken('HammerGestureConfig');
/**
 * @record
 */

/**
 * \@experimental
 */
var HammerGestureConfig = /** @class */ (function () {
    function HammerGestureConfig() {
        this.events = [];
        this.overrides = {};
    }
    /**
     * @param {?} element
     * @return {?}
     */
    HammerGestureConfig.prototype.buildHammer = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ mc = new Hammer(element);
        mc.get('pinch').set({ enable: true });
        mc.get('rotate').set({ enable: true });
        for (var /** @type {?} */ eventName in this.overrides) {
            mc.get(eventName).set(this.overrides[eventName]);
        }
        return mc;
    };
    HammerGestureConfig.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    HammerGestureConfig.ctorParameters = function () { return []; };
    return HammerGestureConfig;
}());
var HammerGesturesPlugin = /** @class */ (function (_super) {
    __extends(HammerGesturesPlugin, _super);
    function HammerGesturesPlugin(doc, _config) {
        var _this = _super.call(this, doc) || this;
        _this._config = _config;
        return _this;
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    HammerGesturesPlugin.prototype.supports = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) {
        if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
            return false;
        }
        if (!(/** @type {?} */ (window)).Hammer) {
            throw new Error("Hammer.js is not loaded, can not bind " + eventName + " event");
        }
        return true;
    };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    HammerGesturesPlugin.prototype.addEventListener = /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (element, eventName, handler) {
        var _this = this;
        var /** @type {?} */ zone = this.manager.getZone();
        eventName = eventName.toLowerCase();
        return zone.runOutsideAngular(function () {
            // Creating the manager bind events, must be done outside of angular
            var /** @type {?} */ mc = _this._config.buildHammer(element);
            var /** @type {?} */ callback = function (eventObj) {
                zone.runGuarded(function () { handler(eventObj); });
            };
            mc.on(eventName, callback);
            return function () { return mc.off(eventName, callback); };
        });
    };
    /**
     * @param {?} eventName
     * @return {?}
     */
    HammerGesturesPlugin.prototype.isCustomEvent = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) { return this._config.events.indexOf(eventName) > -1; };
    HammerGesturesPlugin.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    HammerGesturesPlugin.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        { type: HammerGestureConfig, decorators: [{ type: core.Inject, args: [HAMMER_GESTURE_CONFIG,] },] },
    ]; };
    return HammerGesturesPlugin;
}(EventManagerPlugin));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
var ɵ0$1 = function (event) { return event.altKey; };
var ɵ1$1 = function (event) { return event.ctrlKey; };
var ɵ2$1 = function (event) { return event.metaKey; };
var ɵ3 = function (event) { return event.shiftKey; };
var MODIFIER_KEY_GETTERS = {
    'alt': ɵ0$1,
    'control': ɵ1$1,
    'meta': ɵ2$1,
    'shift': ɵ3
};
/**
 * \@experimental
 */
var KeyEventsPlugin = /** @class */ (function (_super) {
    __extends(KeyEventsPlugin, _super);
    function KeyEventsPlugin(doc) {
        return _super.call(this, doc) || this;
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    KeyEventsPlugin.prototype.supports = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) { return KeyEventsPlugin.parseEventName(eventName) != null; };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    KeyEventsPlugin.prototype.addEventListener = /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    function (element, eventName, handler) {
        var /** @type {?} */ parsedEvent = /** @type {?} */ ((KeyEventsPlugin.parseEventName(eventName)));
        var /** @type {?} */ outsideHandler = KeyEventsPlugin.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
        return this.manager.getZone().runOutsideAngular(function () {
            return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
        });
    };
    /**
     * @param {?} eventName
     * @return {?}
     */
    KeyEventsPlugin.parseEventName = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) {
        var /** @type {?} */ parts = eventName.toLowerCase().split('.');
        var /** @type {?} */ domEventName = parts.shift();
        if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
            return null;
        }
        var /** @type {?} */ key = KeyEventsPlugin._normalizeKey(/** @type {?} */ ((parts.pop())));
        var /** @type {?} */ fullKey = '';
        MODIFIER_KEYS.forEach(function (modifierName) {
            var /** @type {?} */ index = parts.indexOf(modifierName);
            if (index > -1) {
                parts.splice(index, 1);
                fullKey += modifierName + '.';
            }
        });
        fullKey += key;
        if (parts.length != 0 || key.length === 0) {
            // returning null instead of throwing to let another plugin process the event
            return null;
        }
        var /** @type {?} */ result = {};
        result['domEventName'] = domEventName;
        result['fullKey'] = fullKey;
        return result;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    KeyEventsPlugin.getEventFullKey = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var /** @type {?} */ fullKey = '';
        var /** @type {?} */ key = getDOM().getEventKey(event);
        key = key.toLowerCase();
        if (key === ' ') {
            key = 'space'; // for readability
        }
        else if (key === '.') {
            key = 'dot'; // because '.' is used as a separator in event names
        }
        MODIFIER_KEYS.forEach(function (modifierName) {
            if (modifierName != key) {
                var /** @type {?} */ modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
                if (modifierGetter(event)) {
                    fullKey += modifierName + '.';
                }
            }
        });
        fullKey += key;
        return fullKey;
    };
    /**
     * @param {?} fullKey
     * @param {?} handler
     * @param {?} zone
     * @return {?}
     */
    KeyEventsPlugin.eventCallback = /**
     * @param {?} fullKey
     * @param {?} handler
     * @param {?} zone
     * @return {?}
     */
    function (fullKey, handler, zone) {
        return function (event /** TODO #9100 */) {
            if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
                zone.runGuarded(function () { return handler(event); });
            }
        };
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} keyName
     * @return {?}
     */
    KeyEventsPlugin._normalizeKey = /**
     * \@internal
     * @param {?} keyName
     * @return {?}
     */
    function (keyName) {
        // TODO: switch to a Map if the mapping grows too much
        switch (keyName) {
            case 'esc':
                return 'escape';
            default:
                return keyName;
        }
    };
    KeyEventsPlugin.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    KeyEventsPlugin.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return KeyEventsPlugin;
}(EventManagerPlugin));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This helper class is used to get hold of an inert tree of DOM elements containing dirty HTML
 * that needs sanitizing.
 * Depending upon browser support we must use one of three strategies for doing this.
 * Support: Safari 10.x -> XHR strategy
 * Support: Firefox -> DomParser strategy
 * Default: InertDocument strategy
 */
var InertBodyHelper = /** @class */ (function () {
    function InertBodyHelper(defaultDoc, DOM) {
        this.defaultDoc = defaultDoc;
        this.DOM = DOM;
        var /** @type {?} */ inertDocument = this.DOM.createHtmlDocument();
        this.inertBodyElement = inertDocument.body;
        if (this.inertBodyElement == null) {
            // usually there should be only one body element in the document, but IE doesn't have any, so
            // we need to create one.
            var /** @type {?} */ inertHtml = this.DOM.createElement('html', inertDocument);
            this.inertBodyElement = this.DOM.createElement('body', inertDocument);
            this.DOM.appendChild(inertHtml, this.inertBodyElement);
            this.DOM.appendChild(inertDocument, inertHtml);
        }
        this.DOM.setInnerHTML(this.inertBodyElement, '<svg><g onload="this.parentNode.remove()"></g></svg>');
        if (this.inertBodyElement.querySelector && !this.inertBodyElement.querySelector('svg')) {
            // We just hit the Safari 10.1 bug - which allows JS to run inside the SVG G element
            // so use the XHR strategy.
            this.getInertBodyElement = this.getInertBodyElement_XHR;
            return;
        }
        this.DOM.setInnerHTML(this.inertBodyElement, '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
        if (this.inertBodyElement.querySelector && this.inertBodyElement.querySelector('svg img')) {
            // We just hit the Firefox bug - which prevents the inner img JS from being sanitized
            // so use the DOMParser strategy, if it is available.
            // If the DOMParser is not available then we are not in Firefox (Server/WebWorker?) so we
            // fall through to the default strategy below.
            if (isDOMParserAvailable()) {
                this.getInertBodyElement = this.getInertBodyElement_DOMParser;
                return;
            }
        }
        // None of the bugs were hit so it is safe for us to use the default InertDocument strategy
        this.getInertBodyElement = this.getInertBodyElement_InertDocument;
    }
    /**
     * Use XHR to create and fill an inert body element (on Safari 10.1)
     * See
     * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
     * @param {?} html
     * @return {?}
     */
    InertBodyHelper.prototype.getInertBodyElement_XHR = /**
     * Use XHR to create and fill an inert body element (on Safari 10.1)
     * See
     * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
     * @param {?} html
     * @return {?}
     */
    function (html) {
        // We add these extra elements to ensure that the rest of the content is parsed as expected
        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
        // `<head>` tag.
        html = '<body><remove></remove>' + html + '</body>';
        try {
            html = encodeURI(html);
        }
        catch (/** @type {?} */ e) {
            return null;
        }
        var /** @type {?} */ xhr = new XMLHttpRequest();
        xhr.responseType = 'document';
        xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
        xhr.send(null);
        var /** @type {?} */ body = xhr.response.body;
        body.removeChild(/** @type {?} */ ((body.firstChild)));
        return body;
    };
    /**
     * Use DOMParser to create and fill an inert body element (on Firefox)
     * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
     *
     * @param {?} html
     * @return {?}
     */
    InertBodyHelper.prototype.getInertBodyElement_DOMParser = /**
     * Use DOMParser to create and fill an inert body element (on Firefox)
     * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
     *
     * @param {?} html
     * @return {?}
     */
    function (html) {
        // We add these extra elements to ensure that the rest of the content is parsed as expected
        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
        // `<head>` tag.
        html = '<body><remove></remove>' + html + '</body>';
        try {
            var /** @type {?} */ body = /** @type {?} */ (new (/** @type {?} */ (window))
                .DOMParser()
                .parseFromString(html, 'text/html')
                .body);
            body.removeChild(/** @type {?} */ ((body.firstChild)));
            return body;
        }
        catch (/** @type {?} */ e) {
            return null;
        }
    };
    /**
     * Use an HTML5 `template` element, if supported, or an inert body element created via
     * `createHtmlDocument` to create and fill an inert DOM element.
     * This is the default sane strategy to use if the browser does not require one of the specialised
     * strategies above.
     * @param {?} html
     * @return {?}
     */
    InertBodyHelper.prototype.getInertBodyElement_InertDocument = /**
     * Use an HTML5 `template` element, if supported, or an inert body element created via
     * `createHtmlDocument` to create and fill an inert DOM element.
     * This is the default sane strategy to use if the browser does not require one of the specialised
     * strategies above.
     * @param {?} html
     * @return {?}
     */
    function (html) {
        // Prefer using <template> element if supported.
        var /** @type {?} */ templateEl = this.DOM.createElement('template');
        if ('content' in templateEl) {
            this.DOM.setInnerHTML(templateEl, html);
            return templateEl;
        }
        this.DOM.setInnerHTML(this.inertBodyElement, html);
        // Support: IE 9-11 only
        // strip custom-namespaced attributes on IE<=11
        if (this.defaultDoc.documentMode) {
            this.stripCustomNsAttrs(this.inertBodyElement);
        }
        return this.inertBodyElement;
    };
    /**
     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
     * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
     * 'ns1:xlink:foo').
     *
     * This is undesirable since we don't want to allow any of these custom attributes. This method
     * strips them all.
     * @param {?} el
     * @return {?}
     */
    InertBodyHelper.prototype.stripCustomNsAttrs = /**
     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
     * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
     * 'ns1:xlink:foo').
     *
     * This is undesirable since we don't want to allow any of these custom attributes. This method
     * strips them all.
     * @param {?} el
     * @return {?}
     */
    function (el) {
        var _this = this;
        this.DOM.attributeMap(el).forEach(function (_, attrName) {
            if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
                _this.DOM.removeAttribute(el, attrName);
            }
        });
        for (var _i = 0, _a = this.DOM.childNodesAsList(el); _i < _a.length; _i++) {
            var n = _a[_i];
            if (this.DOM.isElementNode(n))
                this.stripCustomNsAttrs(/** @type {?} */ (n));
        }
    };
    return InertBodyHelper;
}());
/**
 * We need to determine whether the DOMParser exists in the global context.
 * The try-catch is because, on some browsers, trying to access this property
 * on window can actually throw an error.
 *
 * @suppress {uselessCode}
 * @return {?}
 */
function isDOMParserAvailable() {
    try {
        return !!(/** @type {?} */ (window)).DOMParser;
    }
    catch (/** @type {?} */ e) {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * This regular expression matches a subset of URLs that will not cause script
 * execution if used in URL context within a HTML document. Specifically, this
 * regular expression matches if (comment from here on and regex copied from
 * Soy's EscapingConventions):
 * (1) Either a protocol in a whitelist (http, https, mailto or ftp).
 * (2) or no protocol.  A protocol must be followed by a colon. The below
 *     allows that by allowing colons only after one of the characters [/?#].
 *     A colon after a hash (#) must be in the fragment.
 *     Otherwise, a colon after a (?) must be in a query.
 *     Otherwise, a colon after a single solidus (/) must be in a path.
 *     Otherwise, a colon after a double solidus (//) must be in the authority
 *     (before port).
 *
 * The pattern disallows &, used in HTML entity declarations before
 * one of the characters in [/?#]. This disallows HTML entities used in the
 * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
 * It also disallows HTML entities in the first path part of a relative path,
 * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
 * that. More importantly, it disallows masking of a colon,
 * e.g. "javascript&#58;...".
 *
 * This regular expression was taken from the Closure sanitization library.
 */
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
/**
 * A pattern that matches safe data URLs. Only matches image, video and audio types.
 */
var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
/**
 * @param {?} url
 * @return {?}
 */
function sanitizeUrl(url) {
    url = String(url);
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
        return url;
    if (core.isDevMode()) {
        getDOM().log("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
    }
    return 'unsafe:' + url;
}
/**
 * @param {?} srcset
 * @return {?}
 */
function sanitizeSrcset(srcset) {
    srcset = String(srcset);
    return srcset.split(',').map(function (srcset) { return sanitizeUrl(srcset.trim()); }).join(', ');
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} tags
 * @return {?}
 */
function tagSet(tags) {
    var /** @type {?} */ res = {};
    for (var _i = 0, _a = tags.split(','); _i < _a.length; _i++) {
        var t = _a[_i];
        res[t] = true;
    }
    return res;
}
/**
 * @param {...?} sets
 * @return {?}
 */
function merge() {
    var sets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sets[_i] = arguments[_i];
    }
    var /** @type {?} */ res = {};
    for (var _a = 0, sets_1 = sets; _a < sets_1.length; _a++) {
        var s = sets_1[_a];
        for (var /** @type {?} */ v in s) {
            if (s.hasOwnProperty(v))
                res[v] = true;
        }
    }
    return res;
}
// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements
// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var VOID_ELEMENTS = tagSet('area,br,col,hr,img,wbr');
// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var OPTIONAL_END_TAG_BLOCK_ELEMENTS = tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
var OPTIONAL_END_TAG_INLINE_ELEMENTS = tagSet('rp,rt');
var OPTIONAL_END_TAG_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
// Safe Block Elements - HTML5
var BLOCK_ELEMENTS = merge(OPTIONAL_END_TAG_BLOCK_ELEMENTS, tagSet('address,article,' +
    'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
    'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
// Inline Elements - HTML5
var INLINE_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, tagSet('a,abbr,acronym,audio,b,' +
    'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
    'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
var VALID_ELEMENTS = merge(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
// Attributes that have href and hence need to be sanitized
var URI_ATTRS = tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
// Attributes that have special href set hence need to be sanitized
var SRCSET_ATTRS = tagSet('srcset');
var HTML_ATTRS = tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
    'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
    'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
    'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
    'valign,value,vspace,width');
// NB: This currently consciously doesn't support SVG. SVG sanitization has had several security
// issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
// innerHTML is required, SVG attributes should be added here.
// NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
// can be sanitized, but they increase security surface area without a legitimate use case, so they
// are left out here.
var VALID_ATTRS = merge(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS);
/**
 * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
 * attributes.
 */
var SanitizingHtmlSerializer = /** @class */ (function () {
    function SanitizingHtmlSerializer() {
        this.sanitizedSomething = false;
        this.buf = [];
        this.DOM = getDOM();
    }
    /**
     * @param {?} el
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.sanitizeChildren = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
        // However this code never accesses properties off of `document` before deleting its contents
        // again, so it shouldn't be vulnerable to DOM clobbering.
        var /** @type {?} */ current = /** @type {?} */ ((this.DOM.firstChild(el)));
        while (current) {
            if (this.DOM.isElementNode(current)) {
                this.startElement(/** @type {?} */ (current));
            }
            else if (this.DOM.isTextNode(current)) {
                this.chars(/** @type {?} */ ((this.DOM.nodeValue(current))));
            }
            else {
                // Strip non-element, non-text nodes.
                this.sanitizedSomething = true;
            }
            if (this.DOM.firstChild(current)) {
                current = /** @type {?} */ ((this.DOM.firstChild(current)));
                continue;
            }
            while (current) {
                // Leaving the element. Walk up and to the right, closing tags as we go.
                if (this.DOM.isElementNode(current)) {
                    this.endElement(/** @type {?} */ (current));
                }
                var /** @type {?} */ next = this.checkClobberedElement(current, /** @type {?} */ ((this.DOM.nextSibling(current))));
                if (next) {
                    current = next;
                    break;
                }
                current = this.checkClobberedElement(current, /** @type {?} */ ((this.DOM.parentElement(current))));
            }
        }
        return this.buf.join('');
    };
    /**
     * @param {?} element
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.startElement = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var _this = this;
        var /** @type {?} */ tagName = this.DOM.nodeName(element).toLowerCase();
        if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
            this.sanitizedSomething = true;
            return;
        }
        this.buf.push('<');
        this.buf.push(tagName);
        this.DOM.attributeMap(element).forEach(function (value, attrName) {
            var /** @type {?} */ lower = attrName.toLowerCase();
            if (!VALID_ATTRS.hasOwnProperty(lower)) {
                _this.sanitizedSomething = true;
                return;
            }
            // TODO(martinprobst): Special case image URIs for data:image/...
            if (URI_ATTRS[lower])
                value = sanitizeUrl(value);
            if (SRCSET_ATTRS[lower])
                value = sanitizeSrcset(value);
            _this.buf.push(' ');
            _this.buf.push(attrName);
            _this.buf.push('="');
            _this.buf.push(encodeEntities(value));
            _this.buf.push('"');
        });
        this.buf.push('>');
    };
    /**
     * @param {?} current
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.endElement = /**
     * @param {?} current
     * @return {?}
     */
    function (current) {
        var /** @type {?} */ tagName = this.DOM.nodeName(current).toLowerCase();
        if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
            this.buf.push('</');
            this.buf.push(tagName);
            this.buf.push('>');
        }
    };
    /**
     * @param {?} chars
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.chars = /**
     * @param {?} chars
     * @return {?}
     */
    function (chars) { this.buf.push(encodeEntities(chars)); };
    /**
     * @param {?} node
     * @param {?} nextNode
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.checkClobberedElement = /**
     * @param {?} node
     * @param {?} nextNode
     * @return {?}
     */
    function (node, nextNode) {
        if (nextNode && this.DOM.contains(node, nextNode)) {
            throw new Error("Failed to sanitize html because the element is clobbered: " + this.DOM.getOuterHTML(node));
        }
        return nextNode;
    };
    return SanitizingHtmlSerializer;
}());
// Regular Expressions for parsing tags and attributes
var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// ! to ~ is the ASCII range.
var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param {?} value
 * @return {?}
 */
function encodeEntities(value) {
    return value.replace(/&/g, '&amp;')
        .replace(SURROGATE_PAIR_REGEXP, function (match) {
        var /** @type {?} */ hi = match.charCodeAt(0);
        var /** @type {?} */ low = match.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    })
        .replace(NON_ALPHANUMERIC_REGEXP, function (match) { return '&#' + match.charCodeAt(0) + ';'; })
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
var inertBodyHelper;
/**
 * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
 * the DOM in a browser environment.
 * @param {?} defaultDoc
 * @param {?} unsafeHtmlInput
 * @return {?}
 */
function sanitizeHtml(defaultDoc, unsafeHtmlInput) {
    var /** @type {?} */ DOM = getDOM();
    var /** @type {?} */ inertBodyElement = null;
    try {
        inertBodyHelper = inertBodyHelper || new InertBodyHelper(defaultDoc, DOM);
        // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
        var /** @type {?} */ unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
        inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
        // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
        // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
        var /** @type {?} */ mXSSAttempts = 5;
        var /** @type {?} */ parsedHtml = unsafeHtml;
        do {
            if (mXSSAttempts === 0) {
                throw new Error('Failed to sanitize html because the input is unstable');
            }
            mXSSAttempts--;
            unsafeHtml = parsedHtml;
            parsedHtml = DOM.getInnerHTML(inertBodyElement);
            inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
        } while (unsafeHtml !== parsedHtml);
        var /** @type {?} */ sanitizer = new SanitizingHtmlSerializer();
        var /** @type {?} */ safeHtml = sanitizer.sanitizeChildren(DOM.getTemplateContent(inertBodyElement) || inertBodyElement);
        if (core.isDevMode() && sanitizer.sanitizedSomething) {
            DOM.log('WARNING: sanitizing HTML stripped some content (see http://g.co/ng/security#xss).');
        }
        return safeHtml;
    }
    finally {
        // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
        if (inertBodyElement) {
            var /** @type {?} */ parent_1 = DOM.getTemplateContent(inertBodyElement) || inertBodyElement;
            for (var _i = 0, _a = DOM.childNodesAsList(parent_1); _i < _a.length; _i++) {
                var child = _a[_i];
                DOM.removeChild(parent_1, child);
            }
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Regular expression for safe style values.
 *
 * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
 *
 * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
 * font-family) and hence could allow multiple values to get injected, but that should pose no risk
 * of XSS.
 *
 * The function expression checks only for XSS safety, not for CSS validity.
 *
 * This regular expression was taken from the Closure sanitization library, and augmented for
 * transformation values.
 */
var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|3d)?';
var COLOR_FNS = '(?:rgb|hsl)a?';
var GRADIENTS = '(?:repeating-)?(?:linear|radial)-gradient';
var CSS3_FNS = '(?:calc|attr)';
var FN_ARGS = '\\([-0-9.%, #a-zA-Z]+\\)';
var SAFE_STYLE_VALUE = new RegExp("^(" + VALUES + "|" +
    ("(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + "|" + GRADIENTS + "|" + CSS3_FNS + ")") +
    (FN_ARGS + ")$"), 'g');
/**
 * Matches a `url(...)` value with an arbitrary argument as long as it does
 * not contain parentheses.
 *
 * The URL value still needs to be sanitized separately.
 *
 * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
 * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
 * by observing whether scroll bars are displayed, or character ranges used by a font face
 * definition.
 *
 * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
 * binding a URL value without further cooperation from the page will cause an information leak, and
 * if so, it is just a leak, not a full blown XSS vulnerability.
 *
 * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
 * code is permissive and allows URLs that sanitize otherwise.
 */
var URL_RE = /^url\(([^)]+)\)$/;
/**
 * Checks that quotes (" and ') are properly balanced inside a string. Assumes
 * that neither escape (\) nor any other character that could result in
 * breaking out of a string parsing context are allowed;
 * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
 *
 * This code was taken from the Closure sanitization library.
 * @param {?} value
 * @return {?}
 */
function hasBalancedQuotes(value) {
    var /** @type {?} */ outsideSingle = true;
    var /** @type {?} */ outsideDouble = true;
    for (var /** @type {?} */ i = 0; i < value.length; i++) {
        var /** @type {?} */ c = value.charAt(i);
        if (c === '\'' && outsideDouble) {
            outsideSingle = !outsideSingle;
        }
        else if (c === '"' && outsideSingle) {
            outsideDouble = !outsideDouble;
        }
    }
    return outsideSingle && outsideDouble;
}
/**
 * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
 * value) and returns a value that is safe to use in a browser environment.
 * @param {?} value
 * @return {?}
 */
function sanitizeStyle(value) {
    value = String(value).trim(); // Make sure it's actually a string.
    if (!value)
        return '';
    // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
    // reasoning behind this.
    var /** @type {?} */ urlMatch = value.match(URL_RE);
    if ((urlMatch && sanitizeUrl(urlMatch[1]) === urlMatch[1]) ||
        value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
        return value; // Safe style values.
    }
    if (core.isDevMode()) {
        getDOM().log("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
    }
    return 'unsafe';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Marker interface for a value that's safe to use in a particular context.
 *
 * \@stable
 * @record
 */

/**
 * Marker interface for a value that's safe to use as HTML.
 *
 * \@stable
 * @record
 */

/**
 * Marker interface for a value that's safe to use as style (CSS).
 *
 * \@stable
 * @record
 */

/**
 * Marker interface for a value that's safe to use as JavaScript.
 *
 * \@stable
 * @record
 */

/**
 * Marker interface for a value that's safe to use as a URL linking to a document.
 *
 * \@stable
 * @record
 */

/**
 * Marker interface for a value that's safe to use as a URL to load executable code from.
 *
 * \@stable
 * @record
 */

/**
 * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
 * values to be safe to use in the different DOM contexts.
 *
 * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
 * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
 * the website.
 *
 * In specific situations, it might be necessary to disable sanitization, for example if the
 * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
 * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
 * methods, and then binding to that value from the template.
 *
 * These situations should be very rare, and extraordinary care must be taken to avoid creating a
 * Cross Site Scripting (XSS) security bug!
 *
 * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
 * close as possible to the source of the value, to make it easy to verify no security bug is
 * created by its use.
 *
 * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
 * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
 * code. The sanitizer leaves safe values intact.
 *
 * \@security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
 * sanitization for the value passed in. Carefully check and audit all values and code paths going
 * into this call. Make sure any user data is appropriately escaped for this security context.
 * For more detail, see the [Security Guide](http://g.co/ng/security).
 *
 * \@stable
 * @abstract
 */
var DomSanitizer = /** @class */ (function () {
    function DomSanitizer() {
    }
    return DomSanitizer;
}());
var DomSanitizerImpl = /** @class */ (function (_super) {
    __extends(DomSanitizerImpl, _super);
    function DomSanitizerImpl(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        return _this;
    }
    /**
     * @param {?} ctx
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.sanitize = /**
     * @param {?} ctx
     * @param {?} value
     * @return {?}
     */
    function (ctx, value) {
        if (value == null)
            return null;
        switch (ctx) {
            case core.SecurityContext.NONE:
                return /** @type {?} */ (value);
            case core.SecurityContext.HTML:
                if (value instanceof SafeHtmlImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'HTML');
                return sanitizeHtml(this._doc, String(value));
            case core.SecurityContext.STYLE:
                if (value instanceof SafeStyleImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Style');
                return sanitizeStyle(/** @type {?} */ (value));
            case core.SecurityContext.SCRIPT:
                if (value instanceof SafeScriptImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Script');
                throw new Error('unsafe value used in a script context');
            case core.SecurityContext.URL:
                if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                    // Allow resource URLs in URL contexts, they are strictly more trusted.
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'URL');
                return sanitizeUrl(String(value));
            case core.SecurityContext.RESOURCE_URL:
                if (value instanceof SafeResourceUrlImpl) {
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'ResourceURL');
                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
            default:
                throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
        }
    };
    /**
     * @param {?} value
     * @param {?} expectedType
     * @return {?}
     */
    DomSanitizerImpl.prototype.checkNotSafeValue = /**
     * @param {?} value
     * @param {?} expectedType
     * @return {?}
     */
    function (value, expectedType) {
        if (value instanceof SafeValueImpl) {
            throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
                "(see http://g.co/ng/security#xss)");
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustHtml = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return new SafeHtmlImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustStyle = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return new SafeStyleImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustScript = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return new SafeScriptImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustUrl = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { return new SafeUrlImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return new SafeResourceUrlImpl(value);
    };
    DomSanitizerImpl.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    DomSanitizerImpl.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
    ]; };
    return DomSanitizerImpl;
}(DomSanitizer));
/**
 * @abstract
 */
var SafeValueImpl = /** @class */ (function () {
    function SafeValueImpl(changingThisBreaksApplicationSecurity) {
        // empty
        this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
    }
    /**
     * @return {?}
     */
    SafeValueImpl.prototype.toString = /**
     * @return {?}
     */
    function () {
        return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
            " (see http://g.co/ng/security#xss)";
    };
    return SafeValueImpl;
}());
var SafeHtmlImpl = /** @class */ (function (_super) {
    __extends(SafeHtmlImpl, _super);
    function SafeHtmlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeHtmlImpl.prototype.getTypeName = /**
     * @return {?}
     */
    function () { return 'HTML'; };
    return SafeHtmlImpl;
}(SafeValueImpl));
var SafeStyleImpl = /** @class */ (function (_super) {
    __extends(SafeStyleImpl, _super);
    function SafeStyleImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeStyleImpl.prototype.getTypeName = /**
     * @return {?}
     */
    function () { return 'Style'; };
    return SafeStyleImpl;
}(SafeValueImpl));
var SafeScriptImpl = /** @class */ (function (_super) {
    __extends(SafeScriptImpl, _super);
    function SafeScriptImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeScriptImpl.prototype.getTypeName = /**
     * @return {?}
     */
    function () { return 'Script'; };
    return SafeScriptImpl;
}(SafeValueImpl));
var SafeUrlImpl = /** @class */ (function (_super) {
    __extends(SafeUrlImpl, _super);
    function SafeUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeUrlImpl.prototype.getTypeName = /**
     * @return {?}
     */
    function () { return 'URL'; };
    return SafeUrlImpl;
}(SafeValueImpl));
var SafeResourceUrlImpl = /** @class */ (function (_super) {
    __extends(SafeResourceUrlImpl, _super);
    function SafeResourceUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeResourceUrlImpl.prototype.getTypeName = /**
     * @return {?}
     */
    function () { return 'ResourceURL'; };
    return SafeResourceUrlImpl;
}(SafeValueImpl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
    { provide: core.PLATFORM_ID, useValue: common.ɵPLATFORM_BROWSER_ID },
    { provide: core.PLATFORM_INITIALIZER, useValue: initDomAdapter, multi: true },
    { provide: common.PlatformLocation, useClass: BrowserPlatformLocation, deps: [DOCUMENT$1] },
    { provide: DOCUMENT$1, useFactory: _document, deps: [] },
];
/**
 * \@security Replacing built-in sanitization providers exposes the application to XSS risks.
 * Attacker-controlled data introduced by an unsanitized provider could expose your
 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
 * \@experimental
 */
var BROWSER_SANITIZATION_PROVIDERS = [
    { provide: core.Sanitizer, useExisting: DomSanitizer },
    { provide: DomSanitizer, useClass: DomSanitizerImpl, deps: [DOCUMENT$1] },
];
/**
 * \@stable
 */
var platformBrowser = core.createPlatformFactory(core.platformCore, 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
/**
 * @return {?}
 */
function initDomAdapter() {
    BrowserDomAdapter.makeCurrent();
    BrowserGetTestability.init();
}
/**
 * @return {?}
 */
function errorHandler() {
    return new core.ErrorHandler();
}
/**
 * @return {?}
 */
function _document() {
    return document;
}
/**
 * The ng module for the browser.
 *
 * \@stable
 */
var BrowserModule = /** @class */ (function () {
    function BrowserModule(parentModule) {
        if (parentModule) {
            throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
        }
    }
    /**
     * Configures a browser-based application to transition from a server-rendered app, if
     * one is present on the page. The specified parameters must include an application id,
     * which must match between the client and server applications.
     *
     * @experimental
     */
    /**
     * Configures a browser-based application to transition from a server-rendered app, if
     * one is present on the page. The specified parameters must include an application id,
     * which must match between the client and server applications.
     *
     * \@experimental
     * @param {?} params
     * @return {?}
     */
    BrowserModule.withServerTransition = /**
     * Configures a browser-based application to transition from a server-rendered app, if
     * one is present on the page. The specified parameters must include an application id,
     * which must match between the client and server applications.
     *
     * \@experimental
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return {
            ngModule: BrowserModule,
            providers: [
                { provide: core.APP_ID, useValue: params.appId },
                { provide: TRANSITION_ID, useExisting: core.APP_ID },
                SERVER_TRANSITION_PROVIDERS,
            ],
        };
    };
    BrowserModule.decorators = [
        { type: core.NgModule, args: [{
                    providers: [
                        BROWSER_SANITIZATION_PROVIDERS,
                        { provide: core.ErrorHandler, useFactory: errorHandler, deps: [] },
                        { provide: EVENT_MANAGER_PLUGINS, useClass: DomEventsPlugin, multi: true },
                        { provide: EVENT_MANAGER_PLUGINS, useClass: KeyEventsPlugin, multi: true },
                        { provide: EVENT_MANAGER_PLUGINS, useClass: HammerGesturesPlugin, multi: true },
                        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
                        DomRendererFactory2,
                        { provide: core.RendererFactory2, useExisting: DomRendererFactory2 },
                        { provide: SharedStylesHost, useExisting: DomSharedStylesHost },
                        DomSharedStylesHost,
                        core.Testability,
                        EventManager,
                        ELEMENT_PROBE_PROVIDERS,
                        Meta,
                        Title,
                    ],
                    exports: [common.CommonModule, core.ApplicationModule]
                },] },
    ];
    /** @nocollapse */
    BrowserModule.ctorParameters = function () { return [
        { type: BrowserModule, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
    ]; };
    return BrowserModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var win = typeof window !== 'undefined' && window || /** @type {?} */ ({});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ChangeDetectionPerfRecord = /** @class */ (function () {
    function ChangeDetectionPerfRecord(msPerTick, numTicks) {
        this.msPerTick = msPerTick;
        this.numTicks = numTicks;
    }
    return ChangeDetectionPerfRecord;
}());
/**
 * Entry point for all Angular profiling-related debug tools. This object
 * corresponds to the `ng.profiler` in the dev console.
 */
var AngularProfiler = /** @class */ (function () {
    function AngularProfiler(ref) {
        this.appRef = ref.injector.get(core.ApplicationRef);
    }
    // tslint:disable:no-console
    /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     */
    /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     * @param {?} config
     * @return {?}
     */
    AngularProfiler.prototype.timeChangeDetection = /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var /** @type {?} */ record = config && config['record'];
        var /** @type {?} */ profileName = 'Change Detection';
        // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
        var /** @type {?} */ isProfilerAvailable = win.console.profile != null;
        if (record && isProfilerAvailable) {
            win.console.profile(profileName);
        }
        var /** @type {?} */ start = getDOM().performanceNow();
        var /** @type {?} */ numTicks = 0;
        while (numTicks < 5 || (getDOM().performanceNow() - start) < 500) {
            this.appRef.tick();
            numTicks++;
        }
        var /** @type {?} */ end = getDOM().performanceNow();
        if (record && isProfilerAvailable) {
            // need to cast to <any> because type checker thinks there's no argument
            // while in fact there is:
            //
            // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
            (/** @type {?} */ (win.console.profileEnd))(profileName);
        }
        var /** @type {?} */ msPerTick = (end - start) / numTicks;
        win.console.log("ran " + numTicks + " change detection cycles");
        win.console.log(msPerTick.toFixed(2) + " ms per check");
        return new ChangeDetectionPerfRecord(msPerTick, numTicks);
    };
    return AngularProfiler;
}());

/**
 * A key value store that is transferred from the application on the server side to the application
 * on the client side.
 *
 * `TransferState` will be available as an injectable token. To use it import
 * `ServerTransferStateModule` on the server and `BrowserTransferStateModule` on the client.
 *
 * The values in the store are serialized/deserialized using JSON.stringify/JSON.parse. So only
 * boolean, number, string, null and non-class objects will be serialized and deserialzied in a
 * non-lossy manner.
 *
 * \@experimental
 */
var TransferState = /** @class */ (function () {
    function TransferState() {
        this.store = {};
        this.onSerializeCallbacks = {};
    }
    /** @internal */
    /**
     * \@internal
     * @param {?} initState
     * @return {?}
     */
    TransferState.init = /**
     * \@internal
     * @param {?} initState
     * @return {?}
     */
    function (initState) {
        var /** @type {?} */ transferState = new TransferState();
        transferState.store = initState;
        return transferState;
    };
    /**
     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
     */
    /**
     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
     * @template T
     * @param {?} key
     * @param {?} defaultValue
     * @return {?}
     */
    TransferState.prototype.get = /**
     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
     * @template T
     * @param {?} key
     * @param {?} defaultValue
     * @return {?}
     */
    function (key, defaultValue) {
        return this.store[key] !== undefined ? /** @type {?} */ (this.store[key]) : defaultValue;
    };
    /**
     * Set the value corresponding to a key.
     */
    /**
     * Set the value corresponding to a key.
     * @template T
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    TransferState.prototype.set = /**
     * Set the value corresponding to a key.
     * @template T
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) { this.store[key] = value; };
    /**
     * Remove a key from the store.
     */
    /**
     * Remove a key from the store.
     * @template T
     * @param {?} key
     * @return {?}
     */
    TransferState.prototype.remove = /**
     * Remove a key from the store.
     * @template T
     * @param {?} key
     * @return {?}
     */
    function (key) { delete this.store[key]; };
    /**
     * Test whether a key exists in the store.
     */
    /**
     * Test whether a key exists in the store.
     * @template T
     * @param {?} key
     * @return {?}
     */
    TransferState.prototype.hasKey = /**
     * Test whether a key exists in the store.
     * @template T
     * @param {?} key
     * @return {?}
     */
    function (key) { return this.store.hasOwnProperty(key); };
    /**
     * Register a callback to provide the value for a key when `toJson` is called.
     */
    /**
     * Register a callback to provide the value for a key when `toJson` is called.
     * @template T
     * @param {?} key
     * @param {?} callback
     * @return {?}
     */
    TransferState.prototype.onSerialize = /**
     * Register a callback to provide the value for a key when `toJson` is called.
     * @template T
     * @param {?} key
     * @param {?} callback
     * @return {?}
     */
    function (key, callback) {
        this.onSerializeCallbacks[key] = callback;
    };
    /**
     * Serialize the current state of the store to JSON.
     */
    /**
     * Serialize the current state of the store to JSON.
     * @return {?}
     */
    TransferState.prototype.toJson = /**
     * Serialize the current state of the store to JSON.
     * @return {?}
     */
    function () {
        // Call the onSerialize callbacks and put those values into the store.
        for (var /** @type {?} */ key in this.onSerializeCallbacks) {
            if (this.onSerializeCallbacks.hasOwnProperty(key)) {
                try {
                    this.store[key] = this.onSerializeCallbacks[key]();
                }
                catch (/** @type {?} */ e) {
                    console.warn('Exception in onSerialize callback: ', e);
                }
            }
        }
        return JSON.stringify(this.store);
    };
    TransferState.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    TransferState.ctorParameters = function () { return []; };
    return TransferState;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var VERSION = new core.Version('5.2.9');

/**
 * @license ng-api-institution
 * MIT license
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TransferEnviromentService = (function () {
    function TransferEnviromentService() {
        this.enviroment = {};
    }
    /**
     * @return {?}
     */
    TransferEnviromentService.prototype.getEnviroment = /**
     * @return {?}
     */
    function () {
        return this.enviroment;
    };
    /**
     * @return {?}
     */
    TransferEnviromentService.prototype.getToken = /**
     * @return {?}
     */
    function () {
        return '';
    };
    TransferEnviromentService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    TransferEnviromentService.ctorParameters = function () { return []; };
    return TransferEnviromentService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * \@name IInstitutionGet
 *
 * @param *id - Идентификатор организации
 * @record
 */

/**
 * \@name IEducationServiceGet
 *
 * @param *id - Идентификатор образовательной услуги
 * @record
 */

/**
 * \@name IBuildingGet
 *
 * @param *id - Идентификатор здания
 * @record
 */

/**
 * \@name IDepartmentGet
 *
 * @param *id - Идентификатор подразделения
 * @record
 */

/**
 * \@name IInnovationGet
 *
 * @param *id - Идентификатор инновации
 * @record
 */

/**
 * \@name IEducationContractGet
 *
 * @param *id - Идентификатор договора
 * @record
 */

/**
 * \@name IPublicDigitalServiceGet
 *
 * @param *id - Идентификатор услуги
 * @record
 */

/**
 * \@name ITerritoryGet
 *
 * @param *id - Идентификатор территории
 * @record
 */

/**
 * \@name IInstitutionSoftDelete
 *
 * @param *id - Идентификатор организации
 * @record
 */

/**
 * \@name IInstitutionDelete
 *
 * @param *id - Идентификатор организации
 * @record
 */

/**
 * \@name IInstitutionRestore
 *
 * @param *id - Идентификатор организации
 * @record
 */

/**
 * \@name IEducationServiceSoftDelete
 *
 * @param *id - Идентификатор образовательной услуги
 * @record
 */

/**
 * \@name IEducationServiceDelete
 *
 * @param *id - Идентификатор образовательной услуги
 * @record
 */

/**
 * \@name IEducationServiceRestore
 *
 * @param *id - Идентификатор образовательной услуги
 * @record
 */

/**
 * \@name IBuildingSoftDelete
 *
 * @param *id - Идентификатор здания
 * @record
 */

/**
 * \@name IBuildingDelete
 *
 * @param *id - Идентификатор здания
 * @record
 */

/**
 * \@name IBuildingRestore
 *
 * @param *id - Идентификатор здания
 * @record
 */

/**
 * \@name IDepartmentSoftDelete
 *
 * @param *id - Идентификатор подразделения
 * @record
 */

/**
 * \@name IDepartmentDelete
 *
 * @param *id - Идентификатор подразделения
 * @record
 */

/**
 * \@name IDepartmentRestore
 *
 * @param *id - Идентификатор подразделения
 * @record
 */

/**
 * \@name IInnovationSoftDelete
 *
 * @param *id - Идентификатор инновации
 * @record
 */

/**
 * \@name IInnovationDelete
 *
 * @param *id - Идентификатор инновации
 * @record
 */

/**
 * \@name IInnovationRestore
 *
 * @param *id - Идентификатор инновации
 * @record
 */

/**
 * \@name IEducationContractSoftDelete
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности
 * @record
 */

/**
 * \@name IEducationContractDelete
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности
 * @record
 */

/**
 * \@name IEducationContractRestore
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности
 * @record
 */

/**
 * \@name IPublicDigitalServiceSoftDelete
 *
 * @param *id - Идентификатор услуги в электронном виде
 * @record
 */

/**
 * \@name IPublicDigitalServiceDelete
 *
 * @param *id - Идентификатор услуги в электронном виде
 * @record
 */

/**
 * \@name IPublicDigitalServiceRestore
 *
 * @param *id - Идентификатор услуги в электронном виде
 * @record
 */

/**
 * \@name ITerritorySoftDelete
 *
 * @param *id - Идентификатор территории
 * @record
 */

/**
 * \@name ITerritoryDelete
 *
 * @param *id - Идентификатор территории
 * @record
 */

/**
 * \@name ITerritoryRestore
 *
 * @param *id - Идентификатор территории
 * @record
 */

/**
 * \@name IOrganizationList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_regions - Регионы
 * @param p_districts - Районы
 * @param p_okopfs - ОКОПФ
 * @param p_okfses - ОКФС
 * @param p_organization_statuses - Статусы организаций
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IInstitutionList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_regions - Регионы
 * @param p_districts - Районы
 * @param p_institution_types - Типы ОО
 * @param p_institution_kinds - Вид образования
 * @param p_education_levels - Уровени образования
 * @param p_okopfs - ОКОПФ
 * @param p_okfses - ОКФС
 * @param p_institution_statuses - Статус образовательной организации
 * @param p_jurisdictions - Подведомственность
 * @param p_education_orientations - Направленности
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IEducationServiceList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IBuildingList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IDepartmentList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IInnovationList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IEducationContractList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IPublicDigitalServiceList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name ITerritoryList
 *
 * @param p_limit - Количество записей
 * @param p_page - Страница выдачи
 * @param p_search - Поисковая строка
 * @param p_institutions - Образовательные организации
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IInstitutionMap
 *
 * @param p_search - Поисковая строка
 * @param p_regions - Регионы
 * @param p_districts - Районы
 * @param p_institution_types - Типы ОО
 * @param p_institution_kinds - Вид образования
 * @param p_education_levels - Уровени образования
 * @param p_okopfs - ОКОПФ
 * @param p_okfses - ОКФС
 * @param p_institution_statuses - Статус образовательной организации
 * @param p_jurisdictions - Подведомственность
 * @param p_education_orientations - Направленности
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IInstitutionExport
 *
 * @param *format - Формат выгрузки [XLS,XLSX,PDF,DOC,DOCX,RTF,CSV]
 * @param p_search - Поисковая строка
 * @param p_regions - Регионы
 * @param p_districts - Районы
 * @param p_institution_types - Типы ОО
 * @param p_institution_kinds - Вид образования
 * @param p_education_levels - Уровени образования
 * @param p_okopfs - ОКОПФ
 * @param p_okfses - ОКФС
 * @param p_institution_statuses - Статус образовательной организации
 * @param p_jurisdictions - Подведомственность
 * @param p_education_orientations - Направленности
 * @param p_deleted - Показывать удаленные
 * @record
 */

/**
 * \@name IInstitutionGetOrganization
 *
 * @param *id - Идентификатор образовательной организации
 * @record
 */

/**
 * \@name IInstitutionDuplicateInn
 *
 * @param *inn - ИНН юр. лица
 * @record
 */

/**
 * \@name IInstitutionDuplicateOgrn
 *
 * @param *ogrn - ОГРН юр. лица
 * @record
 */

/**
 * \@name IInstitutionSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IEducationServiceSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IBuildingSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IDepartmentSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IInnovationSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IEducationContractSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name IPublicDigitalServiceSave
 *
 * @param *body -
 * @record
 */

/**
 * \@name ITerritorySave
 *
 * @param *body -
 * @record
 */

var InstitutionService = (function () {
    function InstitutionService(base, enviromentService) {
        this.base = base;
        this.enviromentService = enviromentService;
        this.enviroment = enviromentService.getEnviroment();
    }
    /**
     * Получает образовательную организацию и связанное юр. лицо по ее id
     * \@method
     * \@name institutionGet
     * @param {?} data - объект с данными типа IInstitutionGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionGet = /**
     * Получает образовательную организацию и связанное юр. лицо по ее id
     * \@method
     * \@name institutionGet
     * @param {?} data - объект с данными типа IInstitutionGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает образовательную услугу для УФТТ 3.0 ее id
     * \@method
     * \@name educationServiceGet
     * @param {?} data - объект с данными типа IEducationServiceGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceGet = /**
     * Получает образовательную услугу для УФТТ 3.0 ее id
     * \@method
     * \@name educationServiceGet
     * @param {?} data - объект с данными типа IEducationServiceGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает здание по его id
     * \@method
     * \@name buildingGet
     * @param {?} data - объект с данными типа IBuildingGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingGet = /**
     * Получает здание по его id
     * \@method
     * \@name buildingGet
     * @param {?} data - объект с данными типа IBuildingGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает подразделение по его id
     * \@method
     * \@name departmentGet
     * @param {?} data - объект с данными типа IDepartmentGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentGet = /**
     * Получает подразделение по его id
     * \@method
     * \@name departmentGet
     * @param {?} data - объект с данными типа IDepartmentGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает инновацию по его id
     * \@method
     * \@name innovationGet
     * @param {?} data - объект с данными типа IInnovationGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationGet = /**
     * Получает инновацию по его id
     * \@method
     * \@name innovationGet
     * @param {?} data - объект с данными типа IInnovationGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает договор на осуществление образовательной деятельности по его id
     * \@method
     * \@name educationContractGet
     * @param {?} data - объект с данными типа IEducationContractGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractGet = /**
     * Получает договор на осуществление образовательной деятельности по его id
     * \@method
     * \@name educationContractGet
     * @param {?} data - объект с данными типа IEducationContractGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceGet
     * @param {?} data - объект с данными типа IPublicDigitalServiceGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceGet = /**
     * Получает услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceGet
     * @param {?} data - объект с данными типа IPublicDigitalServiceGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает территорию по id
     * \@method
     * \@name territoryGet
     * @param {?} data - объект с данными типа ITerritoryGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territoryGet = /**
     * Получает территорию по id
     * \@method
     * \@name territoryGet
     * @param {?} data - объект с данными типа ITerritoryGet
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/get/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionSoftDelete
     * @param {?} data - объект с данными типа IInstitutionSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionSoftDelete = /**
     * Логически удаляет образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionSoftDelete
     * @param {?} data - объект с данными типа IInstitutionSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionDelete
     * @param {?} data - объект с данными типа IInstitutionDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionDelete = /**
     * Удаляет образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionDelete
     * @param {?} data - объект с данными типа IInstitutionDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionRestore
     * @param {?} data - объект с данными типа IInstitutionRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionRestore = /**
     * Восстанавливает образовательные организации и связанное юр. лицо по id
     * \@method
     * \@name institutionRestore
     * @param {?} data - объект с данными типа IInstitutionRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceSoftDelete
     * @param {?} data - объект с данными типа IEducationServiceSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceSoftDelete = /**
     * Логически удаляет образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceSoftDelete
     * @param {?} data - объект с данными типа IEducationServiceSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceDelete
     * @param {?} data - объект с данными типа IEducationServiceDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceDelete = /**
     * Удаляет образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceDelete
     * @param {?} data - объект с данными типа IEducationServiceDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceRestore
     * @param {?} data - объект с данными типа IEducationServiceRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceRestore = /**
     * Восстанавливает образовательные услуги для УФТТ 3.0 по id
     * \@method
     * \@name educationServiceRestore
     * @param {?} data - объект с данными типа IEducationServiceRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет здания по id
     * \@method
     * \@name buildingSoftDelete
     * @param {?} data - объект с данными типа IBuildingSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingSoftDelete = /**
     * Логически удаляет здания по id
     * \@method
     * \@name buildingSoftDelete
     * @param {?} data - объект с данными типа IBuildingSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет здания по id
     * \@method
     * \@name buildingDelete
     * @param {?} data - объект с данными типа IBuildingDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingDelete = /**
     * Удаляет здания по id
     * \@method
     * \@name buildingDelete
     * @param {?} data - объект с данными типа IBuildingDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает здания по id
     * \@method
     * \@name buildingRestore
     * @param {?} data - объект с данными типа IBuildingRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingRestore = /**
     * Восстанавливает здания по id
     * \@method
     * \@name buildingRestore
     * @param {?} data - объект с данными типа IBuildingRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет подразделения по id
     * \@method
     * \@name departmentSoftDelete
     * @param {?} data - объект с данными типа IDepartmentSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentSoftDelete = /**
     * Логически удаляет подразделения по id
     * \@method
     * \@name departmentSoftDelete
     * @param {?} data - объект с данными типа IDepartmentSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет подразделения по id
     * \@method
     * \@name departmentDelete
     * @param {?} data - объект с данными типа IDepartmentDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentDelete = /**
     * Удаляет подразделения по id
     * \@method
     * \@name departmentDelete
     * @param {?} data - объект с данными типа IDepartmentDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает подразделения по id
     * \@method
     * \@name departmentRestore
     * @param {?} data - объект с данными типа IDepartmentRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentRestore = /**
     * Восстанавливает подразделения по id
     * \@method
     * \@name departmentRestore
     * @param {?} data - объект с данными типа IDepartmentRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет инновации по id
     * \@method
     * \@name innovationSoftDelete
     * @param {?} data - объект с данными типа IInnovationSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationSoftDelete = /**
     * Логически удаляет инновации по id
     * \@method
     * \@name innovationSoftDelete
     * @param {?} data - объект с данными типа IInnovationSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет инновации по id
     * \@method
     * \@name innovationDelete
     * @param {?} data - объект с данными типа IInnovationDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationDelete = /**
     * Удаляет инновации по id
     * \@method
     * \@name innovationDelete
     * @param {?} data - объект с данными типа IInnovationDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает инновации по id
     * \@method
     * \@name innovationRestore
     * @param {?} data - объект с данными типа IInnovationRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationRestore = /**
     * Восстанавливает инновации по id
     * \@method
     * \@name innovationRestore
     * @param {?} data - объект с данными типа IInnovationRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractSoftDelete
     * @param {?} data - объект с данными типа IEducationContractSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractSoftDelete = /**
     * Логически удаляет договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractSoftDelete
     * @param {?} data - объект с данными типа IEducationContractSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractDelete
     * @param {?} data - объект с данными типа IEducationContractDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractDelete = /**
     * Удаляет договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractDelete
     * @param {?} data - объект с данными типа IEducationContractDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractRestore
     * @param {?} data - объект с данными типа IEducationContractRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractRestore = /**
     * Восстанавливает договора на осуществление образовательной деятельности по id
     * \@method
     * \@name educationContractRestore
     * @param {?} data - объект с данными типа IEducationContractRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceSoftDelete
     * @param {?} data - объект с данными типа IPublicDigitalServiceSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceSoftDelete = /**
     * Логически удаляет услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceSoftDelete
     * @param {?} data - объект с данными типа IPublicDigitalServiceSoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceDelete
     * @param {?} data - объект с данными типа IPublicDigitalServiceDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceDelete = /**
     * Удаляет услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceDelete
     * @param {?} data - объект с данными типа IPublicDigitalServiceDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceRestore
     * @param {?} data - объект с данными типа IPublicDigitalServiceRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceRestore = /**
     * Восстанавливает услуги в электронном виде по id
     * \@method
     * \@name publicDigitalServiceRestore
     * @param {?} data - объект с данными типа IPublicDigitalServiceRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Логически удаляет территорию по id
     * \@method
     * \@name territorySoftDelete
     * @param {?} data - объект с данными типа ITerritorySoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territorySoftDelete = /**
     * Логически удаляет территорию по id
     * \@method
     * \@name territorySoftDelete
     * @param {?} data - объект с данными типа ITerritorySoftDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/soft-delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Удаляет территорию по id
     * \@method
     * \@name territoryDelete
     * @param {?} data - объект с данными типа ITerritoryDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territoryDelete = /**
     * Удаляет территорию по id
     * \@method
     * \@name territoryDelete
     * @param {?} data - объект с данными типа ITerritoryDelete
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/delete/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Восстанавливает территорию по id
     * \@method
     * \@name territoryRestore
     * @param {?} data - объект с данными типа ITerritoryRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territoryRestore = /**
     * Восстанавливает территорию по id
     * \@method
     * \@name territoryRestore
     * @param {?} data - объект с данными типа ITerritoryRestore
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/restore/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    };
    /**
     * Получает список юр. лиц в постраничном разбиении
     * \@method
     * \@name organizationList
     * @param {?} data - объект с данными типа IOrganizationList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.organizationList = /**
     * Получает список юр. лиц в постраничном разбиении
     * \@method
     * \@name organizationList
     * @param {?} data - объект с данными типа IOrganizationList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/organization/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map(function (item) {
                    search.push({ param: 'p_regions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_regions', value: '' + data.p_regions });
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map(function (item) {
                    search.push({ param: 'p_districts[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_districts', value: '' + data.p_districts });
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map(function (item) {
                    search.push({ param: 'p_okopfs[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okopfs', value: '' + data.p_okopfs });
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map(function (item) {
                    search.push({ param: 'p_okfses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okfses', value: '' + data.p_okfses });
            }
        }
        if (typeof data.p_organization_statuses !== 'undefined' && data.p_organization_statuses !== null) {
            if (Array.isArray(data.p_organization_statuses)) {
                data.p_organization_statuses.map(function (item) {
                    search.push({ param: 'p_organization_statuses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_organization_statuses', value: '' + data.p_organization_statuses });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список образовательных организаций в постраничном разбиении
     * \@method
     * \@name institutionList
     * @param {?} data - объект с данными типа IInstitutionList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionList = /**
     * Получает список образовательных организаций в постраничном разбиении
     * \@method
     * \@name institutionList
     * @param {?} data - объект с данными типа IInstitutionList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map(function (item) {
                    search.push({ param: 'p_regions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_regions', value: '' + data.p_regions });
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map(function (item) {
                    search.push({ param: 'p_districts[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_districts', value: '' + data.p_districts });
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map(function (item) {
                    search.push({ param: 'p_institution_types[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_types', value: '' + data.p_institution_types });
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map(function (item) {
                    search.push({ param: 'p_institution_kinds[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_kinds', value: '' + data.p_institution_kinds });
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map(function (item) {
                    search.push({ param: 'p_education_levels[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_levels', value: '' + data.p_education_levels });
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map(function (item) {
                    search.push({ param: 'p_okopfs[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okopfs', value: '' + data.p_okopfs });
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map(function (item) {
                    search.push({ param: 'p_okfses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okfses', value: '' + data.p_okfses });
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map(function (item) {
                    search.push({ param: 'p_institution_statuses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_statuses', value: '' + data.p_institution_statuses });
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map(function (item) {
                    search.push({ param: 'p_jurisdictions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_jurisdictions', value: '' + data.p_jurisdictions });
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map(function (item) {
                    search.push({ param: 'p_education_orientations[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_orientations', value: '' + data.p_education_orientations });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список образовательных услуг для УФТТ 3.0 в постраничном разбиении
     * \@method
     * \@name educationServiceList
     * @param {?} data - объект с данными типа IEducationServiceList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceList = /**
     * Получает список образовательных услуг для УФТТ 3.0 в постраничном разбиении
     * \@method
     * \@name educationServiceList
     * @param {?} data - объект с данными типа IEducationServiceList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список зданий в постраничном разбиении
     * \@method
     * \@name buildingList
     * @param {?} data - объект с данными типа IBuildingList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingList = /**
     * Получает список зданий в постраничном разбиении
     * \@method
     * \@name buildingList
     * @param {?} data - объект с данными типа IBuildingList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список подразделений в постраничном разбиении
     * \@method
     * \@name departmentList
     * @param {?} data - объект с данными типа IDepartmentList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentList = /**
     * Получает список подразделений в постраничном разбиении
     * \@method
     * \@name departmentList
     * @param {?} data - объект с данными типа IDepartmentList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список инноваций в постраничном разбиении
     * \@method
     * \@name innovationList
     * @param {?} data - объект с данными типа IInnovationList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationList = /**
     * Получает список инноваций в постраничном разбиении
     * \@method
     * \@name innovationList
     * @param {?} data - объект с данными типа IInnovationList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список договоров на осуществление образовательной деятельности в постраничном разбиении
     * \@method
     * \@name educationContractList
     * @param {?} data - объект с данными типа IEducationContractList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractList = /**
     * Получает список договоров на осуществление образовательной деятельности в постраничном разбиении
     * \@method
     * \@name educationContractList
     * @param {?} data - объект с данными типа IEducationContractList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список услуг в электронном виде в постраничном разбиении
     * \@method
     * \@name publicDigitalServiceList
     * @param {?} data - объект с данными типа IPublicDigitalServiceList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceList = /**
     * Получает список услуг в электронном виде в постраничном разбиении
     * \@method
     * \@name publicDigitalServiceList
     * @param {?} data - объект с данными типа IPublicDigitalServiceList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список территорий в постраничном разбиении
     * \@method
     * \@name territoryList
     * @param {?} data - объект с данными типа ITerritoryList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territoryList = /**
     * Получает список территорий в постраничном разбиении
     * \@method
     * \@name territoryList
     * @param {?} data - объект с данными типа ITerritoryList
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/list';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map(function (item) {
                    search.push({ param: 'p_limit[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_limit', value: '' + data.p_limit });
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map(function (item) {
                    search.push({ param: 'p_page[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_page', value: '' + data.p_page });
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map(function (item) {
                    search.push({ param: 'p_institutions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institutions', value: '' + data.p_institutions });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает список образовательных организаций для вывода на карте
     * \@method
     * \@name institutionMap
     * @param {?} data - объект с данными типа IInstitutionMap
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionMap = /**
     * Получает список образовательных организаций для вывода на карте
     * \@method
     * \@name institutionMap
     * @param {?} data - объект с данными типа IInstitutionMap
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/map';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map(function (item) {
                    search.push({ param: 'p_regions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_regions', value: '' + data.p_regions });
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map(function (item) {
                    search.push({ param: 'p_districts[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_districts', value: '' + data.p_districts });
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map(function (item) {
                    search.push({ param: 'p_institution_types[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_types', value: '' + data.p_institution_types });
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map(function (item) {
                    search.push({ param: 'p_institution_kinds[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_kinds', value: '' + data.p_institution_kinds });
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map(function (item) {
                    search.push({ param: 'p_education_levels[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_levels', value: '' + data.p_education_levels });
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map(function (item) {
                    search.push({ param: 'p_okopfs[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okopfs', value: '' + data.p_okopfs });
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map(function (item) {
                    search.push({ param: 'p_okfses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okfses', value: '' + data.p_okfses });
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map(function (item) {
                    search.push({ param: 'p_institution_statuses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_statuses', value: '' + data.p_institution_statuses });
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map(function (item) {
                    search.push({ param: 'p_jurisdictions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_jurisdictions', value: '' + data.p_jurisdictions });
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map(function (item) {
                    search.push({ param: 'p_education_orientations[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_orientations', value: '' + data.p_education_orientations });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает ссылку для скачивания файла экспорта списка образовательных организаций
     * \@method
     * \@name institutionExport
     * @param {?} data - объект с данными типа IInstitutionExport
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionExport = /**
     * Получает ссылку для скачивания файла экспорта списка образовательных организаций
     * \@method
     * \@name institutionExport
     * @param {?} data - объект с данными типа IInstitutionExport
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/export/{format}'
                .replace(/{format}/ig, (typeof data.format !== 'string')
                ? JSON.stringify(data.format)
                : data.format);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        if (typeof data.p_search !== 'undefined' && data.p_search !== null) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map(function (item) {
                    search.push({ param: 'p_search[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_search', value: '' + data.p_search });
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map(function (item) {
                    search.push({ param: 'p_regions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_regions', value: '' + data.p_regions });
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map(function (item) {
                    search.push({ param: 'p_districts[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_districts', value: '' + data.p_districts });
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map(function (item) {
                    search.push({ param: 'p_institution_types[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_types', value: '' + data.p_institution_types });
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map(function (item) {
                    search.push({ param: 'p_institution_kinds[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_kinds', value: '' + data.p_institution_kinds });
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map(function (item) {
                    search.push({ param: 'p_education_levels[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_levels', value: '' + data.p_education_levels });
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map(function (item) {
                    search.push({ param: 'p_okopfs[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okopfs', value: '' + data.p_okopfs });
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map(function (item) {
                    search.push({ param: 'p_okfses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_okfses', value: '' + data.p_okfses });
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map(function (item) {
                    search.push({ param: 'p_institution_statuses[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_institution_statuses', value: '' + data.p_institution_statuses });
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map(function (item) {
                    search.push({ param: 'p_jurisdictions[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_jurisdictions', value: '' + data.p_jurisdictions });
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map(function (item) {
                    search.push({ param: 'p_education_orientations[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_education_orientations', value: '' + data.p_education_orientations });
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map(function (item) {
                    search.push({ param: 'p_deleted[]', value: '' + item });
                });
            }
            else {
                search.push({ param: 'p_deleted', value: '' + data.p_deleted });
            }
        }
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает юр. лицо по id образовательной организации
     * \@method
     * \@name institutionGetOrganization
     * @param {?} data - объект с данными типа IInstitutionGetOrganization
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionGetOrganization = /**
     * Получает юр. лицо по id образовательной организации
     * \@method
     * \@name institutionGetOrganization
     * @param {?} data - объект с данными типа IInstitutionGetOrganization
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/get-organization/{id}'
                .replace(/{id}/ig, (typeof data.id !== 'string')
                ? JSON.stringify(data.id)
                : data.id);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает идентификаторы образовательной организации по ИНН юр. лица
     * \@method
     * \@name institutionDuplicateInn
     * @param {?} data - объект с данными типа IInstitutionDuplicateInn
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionDuplicateInn = /**
     * Получает идентификаторы образовательной организации по ИНН юр. лица
     * \@method
     * \@name institutionDuplicateInn
     * @param {?} data - объект с данными типа IInstitutionDuplicateInn
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/check-inn/{inn}'
                .replace(/{inn}/ig, (typeof data.inn !== 'string')
                ? JSON.stringify(data.inn)
                : data.inn);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Получает идентификаторы образовательной организации по ОГРН юр. лица
     * \@method
     * \@name institutionDuplicateOgrn
     * @param {?} data - объект с данными типа IInstitutionDuplicateOgrn
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionDuplicateOgrn = /**
     * Получает идентификаторы образовательной организации по ОГРН юр. лица
     * \@method
     * \@name institutionDuplicateOgrn
     * @param {?} data - объект с данными типа IInstitutionDuplicateOgrn
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/check-ogrn/{ogrn}'
                .replace(/{ogrn}/ig, (typeof data.ogrn !== 'string')
                ? JSON.stringify(data.ogrn)
                : data.ogrn);
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    };
    /**
     * Сохраняет образовательную организацию и связанное юридическое лицо
     * \@method
     * \@name institutionSave
     * @param {?} data - объект с данными типа IInstitutionSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.institutionSave = /**
     * Сохраняет образовательную организацию и связанное юридическое лицо
     * \@method
     * \@name institutionSave
     * @param {?} data - объект с данными типа IInstitutionSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/institution/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет образовательную услугу для УФТТ 3.0
     * \@method
     * \@name educationServiceSave
     * @param {?} data - объект с данными типа IEducationServiceSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationServiceSave = /**
     * Сохраняет образовательную услугу для УФТТ 3.0
     * \@method
     * \@name educationServiceSave
     * @param {?} data - объект с данными типа IEducationServiceSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-service/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет здание
     * \@method
     * \@name buildingSave
     * @param {?} data - объект с данными типа IBuildingSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.buildingSave = /**
     * Сохраняет здание
     * \@method
     * \@name buildingSave
     * @param {?} data - объект с данными типа IBuildingSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/building/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет подразделение
     * \@method
     * \@name departmentSave
     * @param {?} data - объект с данными типа IDepartmentSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.departmentSave = /**
     * Сохраняет подразделение
     * \@method
     * \@name departmentSave
     * @param {?} data - объект с данными типа IDepartmentSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/department/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет инновацию
     * \@method
     * \@name innovationSave
     * @param {?} data - объект с данными типа IInnovationSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.innovationSave = /**
     * Сохраняет инновацию
     * \@method
     * \@name innovationSave
     * @param {?} data - объект с данными типа IInnovationSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/innovation/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет договор на осуществление образовательной деятельности
     * \@method
     * \@name educationContractSave
     * @param {?} data - объект с данными типа IEducationContractSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.educationContractSave = /**
     * Сохраняет договор на осуществление образовательной деятельности
     * \@method
     * \@name educationContractSave
     * @param {?} data - объект с данными типа IEducationContractSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/education-contract/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет услуги в электронном виде
     * \@method
     * \@name publicDigitalServiceSave
     * @param {?} data - объект с данными типа IPublicDigitalServiceSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.publicDigitalServiceSave = /**
     * Сохраняет услуги в электронном виде
     * \@method
     * \@name publicDigitalServiceSave
     * @param {?} data - объект с данными типа IPublicDigitalServiceSave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/public-digital-service/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    /**
     * Сохраняет территорию
     * \@method
     * \@name territorySave
     * @param {?} data - объект с данными типа ITerritorySave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    InstitutionService.prototype.territorySave = /**
     * Сохраняет территорию
     * \@method
     * \@name territorySave
     * @param {?} data - объект с данными типа ITerritorySave
     * @param {?=} form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     * @return {?}
     */
    function (data, form) {
        var /** @type {?} */ path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
            '/api/institution/territory/save';
        var /** @type {?} */ headers = [];
        headers.push({ name: 'Access-Control-Allow-Origin', value: '*' });
        headers.push({ name: 'X-Requested-With', value: 'XMLHttpRequest' });
        headers.push({ name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '') });
        var /** @type {?} */ search = [];
        var /** @type {?} */ queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    };
    InstitutionService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    InstitutionService.ctorParameters = function () { return [
        { type: ngApiBaseKit.BaseService, },
        { type: TransferEnviromentService, },
    ]; };
    return InstitutionService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgApiInstitutionModule = (function () {
    function NgApiInstitutionModule() {
    }
    /**
     * Use in AppModule
     * @return {?}
     */
    NgApiInstitutionModule.forRoot = /**
     * Use in AppModule
     * @return {?}
     */
    function () {
        return {
            ngModule: NgApiInstitutionModule,
            providers: [
                InstitutionService,
                ngApiBaseKit.BaseService,
                TransferEnviromentService
            ]
        };
    };
    /**
     * Use in features modules with lazy loading
     * @return {?}
     */
    NgApiInstitutionModule.forChild = /**
     * Use in features modules with lazy loading
     * @return {?}
     */
    function () {
        return {
            ngModule: NgApiInstitutionModule,
            providers: [
                InstitutionService,
                ngApiBaseKit.BaseService,
                TransferEnviromentService
            ]
        };
    };
    NgApiInstitutionModule.decorators = [
        { type: core.NgModule, args: [{
                    declarations: [],
                    exports: [],
                    imports: [
                        BrowserModule,
                        ngApiCommon.NgApiCommonModule.forRoot(),
                        ngApiBaseKit.NgApiBaseKitModule.forRoot(),
                    ]
                },] },
    ];
    /** @nocollapse */
    NgApiInstitutionModule.ctorParameters = function () { return []; };
    return NgApiInstitutionModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InstitutionDocument = (function (_super) {
    __extends(InstitutionDocument, _super);
    function InstitutionDocument(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InstitutionDocument;
}(ngApiCommon.Document));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InnovationDocument = (function (_super) {
    __extends(InnovationDocument, _super);
    function InnovationDocument(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InnovationDocument;
}(ngApiCommon.Document));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationContractDocument = (function (_super) {
    __extends(EducationContractDocument, _super);
    function EducationContractDocument(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationContractDocument;
}(ngApiCommon.Document));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var OrganizationMeta = (function (_super) {
    __extends(OrganizationMeta, _super);
    function OrganizationMeta(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.previous_ogrn = [];
        if (json.previous_ogrn) {
            for (var /** @type {?} */ i in json.previous_ogrn) {
                if (json.previous_ogrn.hasOwnProperty(i)) {
                    _this.previous_ogrn.push(json.previous_ogrn[i] || null);
                }
            }
        }
        _this.description = json.description || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return OrganizationMeta;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Organization = (function (_super) {
    __extends(Organization, _super);
    function Organization(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.okpo = json.okpo || null;
        _this.okato = json.okato || null;
        _this.kpp = json.kpp || null;
        _this.oktmo = new ngApiCommon.ClassifierShort(json.oktmo);
        _this.okogu = json.okogu || null;
        _this.owner = new ngApiCommon.PersonShort(json.owner);
        _this.head = new ngApiCommon.PersonShort(json.head);
        _this.type_of_ownership = new ngApiCommon.ClassifierShort(json.type_of_ownership);
        _this.founders_type = new ngApiCommon.ClassifierShort(json.founders_type);
        _this.status = new ngApiCommon.ClassifierShort(json.status);
        _this.address = new ngApiCommon.Address(json.address);
        _this.district = new ngApiCommon.ClassifierShort(json.district);
        _this.region = new ngApiCommon.ClassifierShort(json.region);
        _this.country = new ngApiCommon.ClassifierShort(json.country);
        _this.okopf = new ngApiCommon.ClassifierShort(json.okopf);
        _this.okfs = new ngApiCommon.ClassifierShort(json.okfs);
        _this.okved = [];
        if (json.okved) {
            for (var /** @type {?} */ i in json.okved) {
                if (json.okved.hasOwnProperty(i)) {
                    _this.okved.push(new ngApiCommon.ClassifierShort(json.okved[i]));
                }
            }
        }
        _this.contacts = [];
        if (json.contacts) {
            for (var /** @type {?} */ i in json.contacts) {
                if (json.contacts.hasOwnProperty(i)) {
                    _this.contacts.push(new ngApiCommon.Contact(json.contacts[i]));
                }
            }
        }
        _this.meta = new OrganizationMeta(json.meta);
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Organization;
}(ngApiCommon.OrganizationShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PublicAdministration = (function (_super) {
    __extends(PublicAdministration, _super);
    function PublicAdministration(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.form = new ngApiCommon.ClassifierShort(json.form);
        _this.foundation_cause = json.foundation_cause || null;
        _this.foundation_date = json.foundation_date || null;
        _this.liquidation_date = json.liquidation_date || null;
        _this.powers = json.powers || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return PublicAdministration;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InnovationShort = (function (_super) {
    __extends(InnovationShort, _super);
    function InnovationShort(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.institution_identity = new ngApiCommon.Identity(json.institution_identity);
        _this.name = json.name || null;
        _this.level = new ngApiCommon.ClassifierShort(json.level);
        _this.activity_direction = new ngApiCommon.ClassifierShort(json.activity_direction);
        _this.activity_start = json.activity_start || null;
        _this.activity_end = json.activity_end || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InnovationShort;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Innovation = (function (_super) {
    __extends(Innovation, _super);
    function Innovation(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.document = [];
        if (json.document) {
            for (var /** @type {?} */ i in json.document) {
                if (json.document.hasOwnProperty(i)) {
                    _this.document.push(new InnovationDocument(json.document[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Innovation;
}(InnovationShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationContractShort = (function (_super) {
    __extends(EducationContractShort, _super);
    function EducationContractShort(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.institution_identity = new ngApiCommon.Identity(json.institution_identity);
        _this.subject = new ngApiCommon.ClassifierShort(json.subject);
        _this.group_count = json.group_count || null;
        _this.contragent_institution = json.contragent_institution || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationContractShort;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationContract = (function (_super) {
    __extends(EducationContract, _super);
    function EducationContract(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.document = [];
        if (json.document) {
            for (var /** @type {?} */ i in json.document) {
                if (json.document.hasOwnProperty(i)) {
                    _this.document.push(new EducationContractDocument(json.document[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationContract;
}(EducationContractShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PublicDigitalServiceShort = (function (_super) {
    __extends(PublicDigitalServiceShort, _super);
    function PublicDigitalServiceShort(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.institution_identity = new ngApiCommon.Identity(json.institution_identity);
        _this.service = new ngApiCommon.ClassifierShort(json.service);
        _this.epgu_url = json.epgu_url || null;
        _this.rpgu_url = json.rpgu_url || null;
        _this.documentation_url = json.documentation_url || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return PublicDigitalServiceShort;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PublicDigitalService = (function (_super) {
    __extends(PublicDigitalService, _super);
    function PublicDigitalService(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return PublicDigitalService;
}(PublicDigitalServiceShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InstitutionMeta = (function (_super) {
    __extends(InstitutionMeta, _super);
    function InstitutionMeta(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.reorganization_name = json.reorganization_name || null;
        _this.additional_name = json.additional_name || null;
        _this.occupied_place = json.occupied_place || null;
        _this.total_place = json.total_place || null;
        _this.educational_program_url = json.educational_program_url || null;
        _this.electronic_diary_vendor = json.electronic_diary_vendor || null;
        _this.electronic_diary_name = json.electronic_diary_name || null;
        _this.electronic_diary_url = json.electronic_diary_url || null;
        _this.is_first_class = json.is_first_class || null;
        _this.is_site_initialized = json.is_site_initialized || null;
        _this.employee_count = json.employee_count || null;
        _this.statute_url = json.statute_url || null;
        _this.direction_for_ip = json.direction_for_ip || null;
        _this.has_bookkeeping = json.has_bookkeeping || null;
        _this.is_small_setted = json.is_small_setted || null;
        _this.schedule_string = json.schedule_string || null;
        _this.has_it_teachers = json.has_it_teachers || null;
        _this.is_budget_transfered = json.is_budget_transfered || null;
        _this.fgos_scoring = [];
        if (json.fgos_scoring) {
            for (var /** @type {?} */ i in json.fgos_scoring) {
                if (json.fgos_scoring.hasOwnProperty(i)) {
                    _this.fgos_scoring.push(new ngApiCommon.ClassifierShort(json.fgos_scoring[i]));
                }
            }
        }
        _this.site_characteristics = [];
        if (json.site_characteristics) {
            for (var /** @type {?} */ i in json.site_characteristics) {
                if (json.site_characteristics.hasOwnProperty(i)) {
                    _this.site_characteristics.push(new ngApiCommon.ClassifierShort(json.site_characteristics[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InstitutionMeta;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Equipment = (function (_super) {
    __extends(Equipment, _super);
    function Equipment(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.parent = json.parent || null;
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.code = json.code || null;
        _this.name = json.name || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Equipment;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PlaceEquipment = (function (_super) {
    __extends(PlaceEquipment, _super);
    function PlaceEquipment(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.equipment = new Equipment(json.equipment);
        _this.quantity = json.quantity || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return PlaceEquipment;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RoomSeat = (function (_super) {
    __extends(RoomSeat, _super);
    function RoomSeat(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.id = json.id || null;
        _this.row_number = json.row_number || null;
        _this.seats = json.seats || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return RoomSeat;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Room = (function (_super) {
    __extends(Room, _super);
    function Room(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.number = json.number || null;
        _this.type = new ngApiCommon.ClassifierShort(json.type);
        _this.name = json.name || null;
        _this.seats = [];
        if (json.seats) {
            for (var /** @type {?} */ i in json.seats) {
                if (json.seats.hasOwnProperty(i)) {
                    _this.seats.push(new RoomSeat(json.seats[i]));
                }
            }
        }
        _this.equipment = [];
        if (json.equipment) {
            for (var /** @type {?} */ i in json.equipment) {
                if (json.equipment.hasOwnProperty(i)) {
                    _this.equipment.push(new PlaceEquipment(json.equipment[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Room;
}(ngApiCommon.RoomShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TerritoryShort = (function (_super) {
    __extends(TerritoryShort, _super);
    function TerritoryShort(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.name = json.name || null;
        _this.institution_identity = new ngApiCommon.Identity(json.institution_identity);
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return TerritoryShort;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Territory = (function (_super) {
    __extends(Territory, _super);
    function Territory(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.equipment = [];
        if (json.equipment) {
            for (var /** @type {?} */ i in json.equipment) {
                if (json.equipment.hasOwnProperty(i)) {
                    _this.equipment.push(new PlaceEquipment(json.equipment[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Territory;
}(TerritoryShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Building = (function (_super) {
    __extends(Building, _super);
    function Building(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.capacity = new ngApiCommon.Capacity(json.capacity);
        _this.address = new ngApiCommon.Address(json.address);
        _this.type = new ngApiCommon.ClassifierShort(json.type);
        _this.terrain = new ngApiCommon.ClassifierShort(json.terrain);
        _this.rooms = [];
        if (json.rooms) {
            for (var /** @type {?} */ i in json.rooms) {
                if (json.rooms.hasOwnProperty(i)) {
                    _this.rooms.push(new Room(json.rooms[i]));
                }
            }
        }
        _this.equipment = [];
        if (json.equipment) {
            for (var /** @type {?} */ i in json.equipment) {
                if (json.equipment.hasOwnProperty(i)) {
                    _this.equipment.push(new PlaceEquipment(json.equipment[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Building;
}(ngApiCommon.BuildingShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Department = (function (_super) {
    __extends(Department, _super);
    function Department(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.capacity = new ngApiCommon.Capacity(json.capacity);
        _this.head = new ngApiCommon.JobShort(json.head);
        _this.address = new ngApiCommon.Address(json.address);
        _this.contacts = [];
        if (json.contacts) {
            for (var /** @type {?} */ i in json.contacts) {
                if (json.contacts.hasOwnProperty(i)) {
                    _this.contacts.push(new ngApiCommon.Contact(json.contacts[i]));
                }
            }
        }
        _this.is_based_on_another_organization = json.is_based_on_another_organization || null;
        _this.foundation_date = json.foundation_date || null;
        _this.liquidation_date = json.liquidation_date || null;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Department;
}(ngApiCommon.DepartmentShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationServiceShort = (function (_super) {
    __extends(EducationServiceShort, _super);
    function EducationServiceShort(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.identity = new ngApiCommon.Identity(json.identity);
        _this.entity_state = new ngApiCommon.EntityState(json.entity_state);
        _this.institution_identity = new ngApiCommon.Identity(json.institution_identity);
        _this.kind = new ngApiCommon.ClassifierShort(json.kind);
        _this.name = json.name || null;
        _this.direction = new ngApiCommon.ClassifierShort(json.direction);
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationServiceShort;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationService = (function (_super) {
    __extends(EducationService, _super);
    function EducationService(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationService;
}(EducationServiceShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Institution = (function (_super) {
    __extends(Institution, _super);
    function Institution(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.organization = new Organization(json.organization);
        _this.head = new ngApiCommon.JobShort(json.head);
        _this.region = new ngApiCommon.ClassifierShort(json.region);
        _this.shift = [];
        if (json.shift) {
            for (var /** @type {?} */ i in json.shift) {
                if (json.shift.hasOwnProperty(i)) {
                    _this.shift.push(new ngApiCommon.ClassifierShort(json.shift[i]));
                }
            }
        }
        _this.status_date = json.status_date || null;
        _this.kind = new ngApiCommon.ClassifierShort(json.kind);
        _this.terrain = new ngApiCommon.ClassifierShort(json.terrain);
        _this.work_time = [];
        if (json.work_time) {
            for (var /** @type {?} */ i in json.work_time) {
                if (json.work_time.hasOwnProperty(i)) {
                    _this.work_time.push(new ngApiCommon.WorkTime(json.work_time[i]));
                }
            }
        }
        _this.education_language = new ngApiCommon.ClassifierShort(json.education_language);
        _this.education_area = [];
        if (json.education_area) {
            for (var /** @type {?} */ i in json.education_area) {
                if (json.education_area.hasOwnProperty(i)) {
                    _this.education_area.push(new ngApiCommon.Address(json.education_area[i]));
                }
            }
        }
        _this.levels = [];
        if (json.levels) {
            for (var /** @type {?} */ i in json.levels) {
                if (json.levels.hasOwnProperty(i)) {
                    _this.levels.push(new ngApiCommon.ClassifierShort(json.levels[i]));
                }
            }
        }
        _this.meals = [];
        if (json.meals) {
            for (var /** @type {?} */ i in json.meals) {
                if (json.meals.hasOwnProperty(i)) {
                    _this.meals.push(new ngApiCommon.Meal(json.meals[i]));
                }
            }
        }
        _this.implement_education_services = [];
        if (json.implement_education_services) {
            for (var /** @type {?} */ i in json.implement_education_services) {
                if (json.implement_education_services.hasOwnProperty(i)) {
                    _this.implement_education_services.push(new ngApiCommon.ClassifierShort(json.implement_education_services[i]));
                }
            }
        }
        _this.ovz_group_types = [];
        if (json.ovz_group_types) {
            for (var /** @type {?} */ i in json.ovz_group_types) {
                if (json.ovz_group_types.hasOwnProperty(i)) {
                    _this.ovz_group_types.push(new ngApiCommon.ClassifierShort(json.ovz_group_types[i]));
                }
            }
        }
        _this.foundation_date = json.foundation_date || null;
        _this.description = json.description || null;
        _this.address = new ngApiCommon.Address(json.address);
        _this.post_address = new ngApiCommon.Address(json.post_address);
        _this.district = new ngApiCommon.ClassifierShort(json.district);
        _this.jurisdiction = new ngApiCommon.ClassifierShort(json.jurisdiction);
        _this.capacity = new ngApiCommon.Capacity(json.capacity);
        _this.documents = [];
        if (json.documents) {
            for (var /** @type {?} */ i in json.documents) {
                if (json.documents.hasOwnProperty(i)) {
                    _this.documents.push(new InstitutionDocument(json.documents[i]));
                }
            }
        }
        _this.public_administration = new PublicAdministration(json.public_administration);
        _this.meta = new InstitutionMeta(json.meta);
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return Institution;
}(ngApiCommon.InstitutionShort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InstitutionFull = (function (_super) {
    __extends(InstitutionFull, _super);
    function InstitutionFull(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.education_services = [];
        if (json.education_services) {
            for (var /** @type {?} */ i in json.education_services) {
                if (json.education_services.hasOwnProperty(i)) {
                    _this.education_services.push(new EducationService(json.education_services[i]));
                }
            }
        }
        _this.buildings = [];
        if (json.buildings) {
            for (var /** @type {?} */ i in json.buildings) {
                if (json.buildings.hasOwnProperty(i)) {
                    _this.buildings.push(new Building(json.buildings[i]));
                }
            }
        }
        _this.territory = [];
        if (json.territory) {
            for (var /** @type {?} */ i in json.territory) {
                if (json.territory.hasOwnProperty(i)) {
                    _this.territory.push(new Territory(json.territory[i]));
                }
            }
        }
        _this.departments = [];
        if (json.departments) {
            for (var /** @type {?} */ i in json.departments) {
                if (json.departments.hasOwnProperty(i)) {
                    _this.departments.push(new Department(json.departments[i]));
                }
            }
        }
        _this.innovations = [];
        if (json.innovations) {
            for (var /** @type {?} */ i in json.innovations) {
                if (json.innovations.hasOwnProperty(i)) {
                    _this.innovations.push(new Innovation(json.innovations[i]));
                }
            }
        }
        _this.education_contracts = [];
        if (json.education_contracts) {
            for (var /** @type {?} */ i in json.education_contracts) {
                if (json.education_contracts.hasOwnProperty(i)) {
                    _this.education_contracts.push(new EducationContract(json.education_contracts[i]));
                }
            }
        }
        _this.public_digital_services = [];
        if (json.public_digital_services) {
            for (var /** @type {?} */ i in json.public_digital_services) {
                if (json.public_digital_services.hasOwnProperty(i)) {
                    _this.public_digital_services.push(new PublicDigitalService(json.public_digital_services[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InstitutionFull;
}(Institution));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var OrganizationList = (function (_super) {
    __extends(OrganizationList, _super);
    function OrganizationList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new ngApiCommon.OrganizationShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return OrganizationList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InstitutionList = (function (_super) {
    __extends(InstitutionList, _super);
    function InstitutionList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new ngApiCommon.InstitutionShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InstitutionList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InstitutionMapList = (function (_super) {
    __extends(InstitutionMapList, _super);
    function InstitutionMapList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new ngApiCommon.InstitutionMapPoint(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InstitutionMapList;
}(ngApiBaseKit.BaseModel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationServiceList = (function (_super) {
    __extends(EducationServiceList, _super);
    function EducationServiceList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new EducationServiceShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationServiceList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BuildingList = (function (_super) {
    __extends(BuildingList, _super);
    function BuildingList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new ngApiCommon.BuildingShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return BuildingList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DepartmentList = (function (_super) {
    __extends(DepartmentList, _super);
    function DepartmentList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new ngApiCommon.DepartmentShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return DepartmentList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InnovationList = (function (_super) {
    __extends(InnovationList, _super);
    function InnovationList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new InnovationShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return InnovationList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EducationContractList = (function (_super) {
    __extends(EducationContractList, _super);
    function EducationContractList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new EducationContractShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return EducationContractList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PublicDigitalServiceList = (function (_super) {
    __extends(PublicDigitalServiceList, _super);
    function PublicDigitalServiceList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new PublicDigitalServiceShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return PublicDigitalServiceList;
}(ngApiCommon.Pagination));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TerritoryList = (function (_super) {
    __extends(TerritoryList, _super);
    function TerritoryList(json) {
        var _this = this;
        if (json === void 0 || json === null) {
            json = {};
        }
        _this = _super.call(this, json) || this;
        _this.items = [];
        if (json.items) {
            for (var /** @type {?} */ i in json.items) {
                if (json.items.hasOwnProperty(i)) {
                    _this.items.push(new TerritoryShort(json.items[i]));
                }
            }
        }
        _this._isEmpty = _this.isEmpty(_this);
        return _this;
    }
    return TerritoryList;
}(ngApiCommon.Pagination));

exports.NgApiInstitutionModule = NgApiInstitutionModule;
exports.InstitutionDocument = InstitutionDocument;
exports.InnovationDocument = InnovationDocument;
exports.EducationContractDocument = EducationContractDocument;
exports.OrganizationMeta = OrganizationMeta;
exports.Organization = Organization;
exports.PublicAdministration = PublicAdministration;
exports.InnovationShort = InnovationShort;
exports.Innovation = Innovation;
exports.EducationContractShort = EducationContractShort;
exports.EducationContract = EducationContract;
exports.PublicDigitalServiceShort = PublicDigitalServiceShort;
exports.PublicDigitalService = PublicDigitalService;
exports.InstitutionMeta = InstitutionMeta;
exports.Equipment = Equipment;
exports.PlaceEquipment = PlaceEquipment;
exports.RoomSeat = RoomSeat;
exports.Room = Room;
exports.TerritoryShort = TerritoryShort;
exports.Territory = Territory;
exports.Building = Building;
exports.Department = Department;
exports.EducationServiceShort = EducationServiceShort;
exports.EducationService = EducationService;
exports.Institution = Institution;
exports.InstitutionFull = InstitutionFull;
exports.OrganizationList = OrganizationList;
exports.InstitutionList = InstitutionList;
exports.InstitutionMapList = InstitutionMapList;
exports.EducationServiceList = EducationServiceList;
exports.BuildingList = BuildingList;
exports.DepartmentList = DepartmentList;
exports.InnovationList = InnovationList;
exports.EducationContractList = EducationContractList;
exports.PublicDigitalServiceList = PublicDigitalServiceList;
exports.TerritoryList = TerritoryList;
exports.InstitutionService = InstitutionService;
exports.TransferEnviromentService = TransferEnviromentService;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=ng-api-institution.umd.js.map
